import "./orderList.css";
import Table from "../../components/advancedTable";
import {
    Close,
    LocalGroceryStore,
    CloudDownload,
    Description,
    LocalShipping,
    VerifiedUser,
    Edit,
    AttachFile,
    Comment,
    FileCopy,
    Map,
    MoneyOff,
} from "@material-ui/icons";
import { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { commonSelectProps } from "../../components/shared/SelectStyles";
import {
    getOrders,
    voidOrder,
    acceptOrder,
    updateOrder,
    generateSignature,
} from "../../redux/apiCalls";
import moment from "moment";
import {
    FiDownload,
    FiFile,
    FiPlus,
    FiPlay,
    FiRotateCcw,
    FiUploadCloud,
    FiX,
} from "react-icons/fi";
import { publicRequest } from "../../requestMethods";
import createCustomerInvoice, {
    createCustomerInvoiceMerged,
    createDeliveryOrder,
} from "../../components/pdf/createCustomerInvoice";
import createOfficialReceipt from "../../components/pdf/createOfficialReceipt";
import {
    PAYMENT_SLOTS,
    RECEIPT_BUTTON_COLORS,
    paymentAmountField,
    paymentReceiptField,
    paymentReceiptType,
} from "../../constants/paymentSlots";
import { Receipt } from "@material-ui/icons";
import excel from "../../components/excel/excel";
import { useHistory } from "react-router";
import createBulk from "../../components/pdf/createBulk";
import { userRequest } from "../../requestMethods";
import { useForm } from "react-hook-form";
import axios from "axios";
import { clearCart, editOrderSeedData } from "../../redux/cartRedux";
import StepCodeTag from "../../components/shared/StepCodeTag";
import { INSTALLMENT_STEP_CODES, WARRANTY_REQUEST_STEP_CODES, OFFICIAL_RECEIPT_STEP_CODES } from "../../constants/workflowStepCodes";
import { PAYMENT_TYPE_OPTIONS, getPaymentTypeLabel } from "../../constants/paymentTypeOptions";
import { getInvoiceSalesBreakdown } from "../../utils/invoiceSalesBreakdown";
import {
    MERGED_INVOICE_ACCOUNT_ID,
    HIDE_DELIVERY_ORDER_ACCOUNT_ID,
    isUserOrPrincipleId,
} from "../../utils/ipohAccount";

const statusOptions = [
    {
        label: "All",
        value: "",
    },
    {
        label: "Draft",
        value: "draft",
    },
    {
        label: "Pending",
        value: "pending",
    },
    {
        label: "Completed",
        value: "completed",
    },
    {
        label: "Failed",
        value: "failed",
    },
    {
        label: "Uploaded Draft",
        value: "uploadedDraft",
    },
    {
        label: "Draft Approved",
        value: "draftApproved",
    },
    {
        label: "Pending Customer Draft",
        value: "pendingCustomerDraft",
    },
    {
        label: "Purchasing",
        value: "purchasing",
    },
    {
        label: "Production",
        value: "production",
    },
    {
        label: "Production Approved",
        value: "productionApproved",
    },
    {
        label: "Installing",
        value: "installing",
    },
    {
        label: "Install Approved",
        value: "installApproved",
    },
    {
        label: "Void",
        value: "void",
    },
];

const sentToAutocountOptions = [
    { label: "All", value: "" },
    { label: "Sent to Autocount", value: "true" },
    { label: "Not Sent", value: "false" },
];

const toDateInputValue = (date) => {
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) return "";
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

const getDefaultDocTime = (date) => {
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) {
        return { hour12: "12", minute: "00", period: "AM" };
    }

    const hours24 = d.getHours();
    const period = hours24 >= 12 ? "PM" : "AM";
    let hour12 = hours24 % 12;
    if (hour12 === 0) hour12 = 12;

    return {
        hour12: String(hour12),
        minute: String(d.getMinutes()).padStart(2, "0"),
        period,
    };
};

const to24HourTime = (hour12, minute, period) => {
    let hours = Number(hour12);
    const minutes = Number(minute);

    if (!Number.isInteger(hours) || hours < 1 || hours > 12) return null;
    if (!Number.isInteger(minutes) || minutes < 0 || minutes > 59) return null;
    if (period !== "AM" && period !== "PM") return null;

    if (period === "AM") {
        if (hours === 12) hours = 0;
    } else if (hours !== 12) {
        hours += 12;
    }

    return { hours, minutes };
};

const AUTOCOUNT_HOUR12_OPTIONS = Array.from({ length: 12 }, (_, i) =>
    String(i + 1)
);
const AUTOCOUNT_MINUTE_OPTIONS = Array.from({ length: 60 }, (_, i) =>
    String(i).padStart(2, "0")
);

const paymentStatusOptions = [
    {
        label: "All",
        value: "",
    },
    {
        label: "Pending",
        value: "pending",
    },
    {
        label: "Completed",
        value: "completed",
    },
    {
        label: "Void",
        value: "void",
    },
    {
        label: "Installment",
        value: "installment",
    },
];

const limitOptions = [
    {
        label: "Basic",
        value: 20,
    },
    {
        label: "Export",
        value: 9999,
    },
];

// YouTube links for each step (10-step process)
const stepYouTubeLinks = {
    1: "https://www.youtube.com/watch?v=pD9Qggfbq-k",
    2: "https://www.youtube.com/watch?v=Pnoj-WQ2LTQ",
    3: "https://www.youtube.com/watch?v=pjY4Glq8zv4",
    4: "https://www.youtube.com/watch?v=0KwIezS_UKY",
    5: "https://www.youtube.com/watch?v=hI62OQ081pk",
    6: "https://www.youtube.com/watch?v=fqopfl5dKkI",
    7: "https://www.youtube.com/watch?v=oOCP7TE_4Lo",
    9: "https://www.youtube.com/watch?v=AmVEevcD0qA",
    10: "https://www.youtube.com/watch?v=XG2ulEqJoXk",
};

// Keeps keystrokes local so typing doesn't re-render the whole order list
const DebouncedFilterInput = ({ onDebouncedChange, delay = 1000, ...inputProps }) => {
    const [draft, setDraft] = useState("");
    const committedRef = useRef("");
    const onDebouncedChangeRef = useRef(onDebouncedChange);
    onDebouncedChangeRef.current = onDebouncedChange;

    useEffect(() => {
        if (draft === committedRef.current) return undefined;
        const timer = setTimeout(() => {
            committedRef.current = draft;
            onDebouncedChangeRef.current(draft);
        }, delay);
        return () => clearTimeout(timer);
    }, [draft, delay]);

    return (
        <input
            {...inputProps}
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
        />
    );
};

const ORDER_IMAGE_GALLERIES = {
    paymentproof: {
        title: "Proof of Payment",
        addTitle: "Add Payment Proof",
        addEndpoint: "/orders/addpaymentproof",
        deleteEndpoint: "/orders/deletepaymentproof",
        uploadFolder: "paymentproof",
        addHint: "Add new proof of payment",
        viewHint: "View proof of payment",
        imageAlt: "Payment Proof",
        emptyText: "No payment proof files",
    },
    warrantyCard: {
        title: "Warranty Card",
        addTitle: "Add Warranty Card",
        addEndpoint: "/orders/addwarrantycard",
        deleteEndpoint: "/orders/deletewarrantycard",
        uploadFolder: "warrantycard",
        addHint: "Add new warranty card",
        viewHint: "View warranty card",
        imageAlt: "Warranty Card",
        emptyText: "No warranty card files",
    },
};

const GalleryFileTile = ({ url, alt }) => {
    const [showAsImage, setShowAsImage] = useState(true);
    const fileName = decodeURIComponent(
        String(url || "").split("?")[0].split("/").pop() || "File"
    );
    const openFile = () => window.open(url, "_blank");

    if (showAsImage) {
        return (
            <img
                src={url}
                alt={alt}
                className="w-full h-full object-cover cursor-pointer"
                onClick={openFile}
                onError={() => setShowAsImage(false)}
            />
        );
    }

    return (
        <div
            className="w-full h-full flex flex-col items-center justify-center gap-3 p-4 cursor-pointer bg-white"
            onClick={openFile}
            title={fileName}
        >
            <FiFile className="text-blue-600" style={{ width: "48px", height: "48px" }} />
            <span className="text-xs font-medium text-gray-700 text-center break-all">
                {fileName}
            </span>
        </div>
    );
};

const EXPENSES_COLUMN_KEYS = [
    "creditCard",
    "commission",
    "freeGive",
    "crane",
    "voucher",
    "drawing",
    "sponsor",
    "addon",
    "threedDrawing",
    "snSstCn",
    "swSstCn",
    "sstCn",
    "accessoryCosting",
];
const PROFIT_EXPENSE_KEYS = EXPENSES_COLUMN_KEYS.filter(
    (key) => key !== "accessoryCosting"
);

const sumOrderMaterialsCost = (order) =>
    (order.materials || []).reduce(
        (sum, material) =>
            material.price && material.quantity
                ? sum + material.price * material.quantity
                : sum,
        0
    );

const sumOrderExpenseKeys = (order, keys) =>
    order.expenses
        ? keys.reduce(
              (sum, key) => sum + parseFloat(order.expenses[key] || 0),
              0
          )
        : 0;

const getExpensesColumnTotal = (order) => {
    const totalCost = parseFloat(order.totalCost) || 0;
    if (totalCost !== 0) return totalCost;
    return (
        sumOrderMaterialsCost(order) +
        sumOrderExpenseKeys(order, EXPENSES_COLUMN_KEYS)
    );
};

const getProfitColumnExpenses = (order) =>
    sumOrderMaterialsCost(order) + sumOrderExpenseKeys(order, PROFIT_EXPENSE_KEYS);

export default function OrderList() {
    const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    const history = useHistory();
    const dispatch = useDispatch();
    const superadmin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isSuperAdmin === true : null
    );
    const [isLoaded, setIsLoaded] = useState(false);
    const currentUser = useSelector((state) => state.user.currentUser);
    const canDownloadMergedInvoice = isUserOrPrincipleId(
        currentUser,
        MERGED_INVOICE_ACCOUNT_ID
    );
    const hideDeliveryOrder = isUserOrPrincipleId(
        currentUser,
        HIDE_DELIVERY_ORDER_ACCOUNT_ID
    );

    const staff = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.type === "staff" : null
    );

    const admin = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.isAdmin : null
    );

    const accountant = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "accountant"
            : null
    );

    const outright = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "outright"
            : null
    );

    const artist = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "drafter"
            : null
    );

    const regularUser = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "user"
            : null
    );

    const purchaser = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "purchaser"
            : null
    );

    const production = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "production"
            : null
    );

    const productionManager = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "productionManager"
            : null
    );

    const installer = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "installer"
            : null
    );

    const installerManager = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "installerManager"
            : null
    );

    const manager = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "manager"
            : null
    );

    const hq = useSelector((state) =>
        state.user.currentUser
            ? state.user.currentUser.type === "HQ"
            : null
    );

    const principle = useSelector((state) =>
        state.user.currentUser ? state.user.currentUser.principle : null
    );
    

    // Check if user should see limited columns (not outright, manager, staff, HQ, superadmin, or accountant)
    const showLimitedColumns = currentUser && !outright && !manager && !staff && !hq && !superadmin && !accountant;
    // Limited users normally see only survey/blueprint in Action; installer managers keep full action controls
    const showSurveyBlueprintOnlyInAction =
        showLimitedColumns && !installerManager;

    const buildDefaultFilters = () => ({
        cashier: staff
            ? currentUser?._id
            : superadmin
            ? undefined
            : outright
            ? undefined
            : undefined,
        status: regularUser
            ? undefined
            : artist
            ? "pending"
            : productionManager
            ? undefined
            : purchaser
            ? undefined
            : production
            ? undefined
            : installer
            ? undefined
            : installerManager
            ? undefined
            : undefined,
        paymentStatus: undefined,
        sentToAutocount: manager ? "false" : undefined,
        limit: 9999,
        page: 1,
        dateFrom: moment("2026-01-01").format("YYYY-MM-DD"),
        dateTo: moment(Date.now()).add(1, "months").format("YYYY-MM-DD"),
        principle: staff
            ? undefined
            : superadmin
            ? undefined
            : regularUser
            ? undefined
            : principle || currentUser?._id,
        // Drafters see all orders for their branch (principle), not only orders where they are assigned,
        // so they can see new orders and assign themselves (e.g. Ipoh drafter sees Ipoh orders).
        artist: artist ? undefined : undefined,
        user: regularUser ? currentUser?._id : undefined,
        purchaser: purchaser ? currentUser?._id : undefined,
        producer: production ? currentUser?._id : undefined,
        installer: installer ? currentUser?._id : undefined, // Installers see only their orders
        installerManager: installerManager ? true : undefined, // productionApproved, installing, installApproved, completed
        sortBy: undefined,
        sortOrder: undefined,
    });
    const [inputs, setInputs] = useState(buildDefaultFilters);

    const [statusMenu, setStatusMenu] = useState(false);
    const [ordersData, setOrdersData] = useState(false);
    const [voidMenu, setVoidMenu] = useState(false);
    const [acceptMenu, setAcceptMenu] = useState(false);
    const [artistMenu, setArtistMenu] = useState(false);
    const [producerMenu, setProducerMenu] = useState(false);
    const [installerMenu, setInstallerMenu] = useState(false);
    const [purchaserMenu, setPurchaserMenu] = useState(false);
    const [productionManagerMenu, setProductionManagerMenu] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [usersData, setUsersData] = useState([]);
    const [customersData, setCustomersData] = useState([]);
    const [artistsData, setArtistsData] = useState([]);
    const [producersData, setProducersData] = useState([]);
    const [installersData, setInstallersData] = useState([]);
    const [purchasersData, setPurchasersData] = useState([]);
    const [suppliersData, setSuppliersData] = useState([]);
    const [productionManagersData, setProductionManagersData] = useState([]);
    const [serialNumber, setSerialNumber] = useState(undefined);
    const [payloadpaymentType, setPayloadPaymentType] = useState("cash");
    const [installmentMenu, setInstallmentMenu] = useState(false);
    const [warrantyMenu, setWarrantyMenu] = useState(false);
    const [autocountMenu, setAutocountMenu] = useState(false);
    const [autocountSubmitting, setAutocountSubmitting] = useState(false);
    const [installmentSubmitting, setInstallmentSubmitting] = useState(false);
    const [autocountDocDate, setAutocountDocDate] = useState("");
    const [autocountDocHour12, setAutocountDocHour12] = useState("");
    const [autocountDocMinute, setAutocountDocMinute] = useState("");
    const [autocountDocPeriod, setAutocountDocPeriod] = useState("AM");
    const [textFiltersResetKey, setTextFiltersResetKey] = useState(0);
    const [daysPending, setDaysPending] = useState("");
    const [completionDays, setCompletionDays] = useState("");
    const [galleryModalState, setGalleryModalState] = useState(false);
    const [photoGalleryModalState, setPhotoGalleryModalState] = useState(false);
    const [galleryViewModalState, setGalleryViewModalState] = useState(false);
    const [selectedOrderGallery, setSelectedOrderGallery] = useState(null);
    const [galleryField, setGalleryField] = useState("paymentproof");
    const galleryConfig = ORDER_IMAGE_GALLERIES[galleryField];
    const [isUploadingGallery, setIsUploadingGallery] = useState(false);
    const [uploadProgress, setUploadProgress] = useState({ current: 0, total: 0 });
    const [remarksMenu, setRemarksMenu] = useState(false);
    const [selectedRemarks, setSelectedRemarks] = useState("");
    const [receiptMenu, setReceiptMenu] = useState(false);
    const [receiptOrderData, setReceiptOrderData] = useState(null);
    const [skip50Menu, setSkip50Menu] = useState(false);
    const [skip50Remarks, setSkip50Remarks] = useState("");
    const [deliveryOrderMenu, setDeliveryOrderMenu] = useState(false);
    const [deliveryOrderSubmitting, setDeliveryOrderSubmitting] = useState(false);
    const deliveryOrderNoRef = useRef(null);
    const [orderIdsWithJournals, setOrderIdsWithJournals] = useState(new Set());
    const [amount, setAmount] = useState(undefined);
    const [installmentReceiptNo, setInstallmentReceiptNo] = useState("");
    // Payment type for the proof being uploaded (gallery / add proof / installment modals)
    const [proofPaymentType, setProofPaymentType] = useState(null);
    // eslint-disable-next-line
    const [paymentType, setPaymentType] = useState([
        {
            label: "Cash",
            value: "cash",
        },
        { value: "onlineTransfer", label: "Online Transfer" },
        { value: "tng", label: "Touch N Go" },
        { value: "cheque", label: "Cheque" },
        { value: "card", label: "Debit Card" },
        { value: "creditCard", label: "Credit Card" },
        { value: "ziip6", label: "ZIIP - 6 months" },
        { value: "ziip12", label: "ZIIP - 12 months" },
        { value: "ziip18", label: "ZIIP - 18 months" },
        { value: "ziip24", label: "ZIIP - 24 months" },
        { value: "others", label: "Others" },
    ]);

    const {
        register: galleryRegister,
        handleSubmit: handleGallerySubmit,
        getValues: getGalleryValues,
        reset: resetGallery,
    } = useForm({
        defaultValues: {
            image: "",
        },
    });

    const {
        register: photoGalleryRegister,
        handleSubmit: handlePhotoGallerySubmit,
        getValues: getPhotoGalleryValues,
        reset: resetPhotoGallery,
    } = useForm({
        defaultValues: {
            image: "",
        },
    });

    const [installmentProofMedia, setInstallmentProofMedia] = useState([]);

    const resetInstallmentProof = () => {
        setInstallmentProofMedia((prev) => {
            prev.forEach((item) => URL.revokeObjectURL(item.previewUrl));
            return [];
        });
        setInstallmentReceiptNo("");
    };

    const handleInstallmentProofSelect = (e) => {
        const files = Array.from(e.target.files || []);
        if (!files.length) return;

        const newItems = files.map((file) => ({
            id: `${Date.now()}-${Math.random()}`,
            file,
            previewUrl: URL.createObjectURL(file),
        }));

        setInstallmentProofMedia((prev) => [...prev, ...newItems]);
        e.target.value = "";
    };

    const removeInstallmentProofMedia = (id) => {
        setInstallmentProofMedia((prev) => {
            const item = prev.find((entry) => entry.id === id);
            if (item) URL.revokeObjectURL(item.previewUrl);
            return prev.filter((entry) => entry.id !== id);
        });
    };

    const {
        register: warrantyRegister,
        handleSubmit: handleWarrantySubmit,
        getValues: getWarrantyValues,
        reset: resetWarranty,
    } = useForm({
        defaultValues: {
            message: "",
            image: "",
        },
    });

    const handleAddGallery = async () => {
        try {
            const formValues = getGalleryValues();

            if (formValues.image.length !== 0 && !proofPaymentType) {
                alert("Please select a payment type");
                return;
            }

            let newImage = undefined;

            if (formValues.image.length !== 0) {
                const imageresult = await generateSignature();
                const imageFormData = new FormData();

                imageFormData.append("file", formValues.image[0]);
                imageFormData.append(
                    "publicKey",
                    "public_0THMWX6MF/cuVk9EPEFy+e0R0Qk="
                );
                imageFormData.append("signature", imageresult.data.signature);
                imageFormData.append("expire", imageresult.data.expire);
                imageFormData.append("token", imageresult.data.token);
                imageFormData.append(
                    "fileName",
                    `${formValues.image[0].name} - ${imageresult.data.expire}`
                );
                imageFormData.append("folder", "paymentproof");

                const imageUploadResult = await axios.post(
                    "https://upload.imagekit.io/api/v1/files/upload",
                    imageFormData
                );

                newImage = imageUploadResult.data.url;
            }

            const result = await userRequest.post("/orders/addpaymentproof", {
                img: newImage,
                order: modalData._id,
                paymentType: proofPaymentType?.value,
            });

            if (result.error) {
                alert("Failed");
            }

            if (result.data) {
                // do success stuff
                resetGalleryModal();
                alert("Success");
                window.location.reload();
            }
        } catch (err) {
            //do err stuff
            alert("Failed");
            console.log(err);
        }
    };

    const handleAddPhotoGallery = async () => {
        try {
            const formValues = getPhotoGalleryValues();

            if (formValues.image.length === 0) {
                alert("Please select at least one file");
                return;
            }

            const uploadedImages = [];
            const totalImages = formValues.image.length;

            // Start loading
            setIsUploadingGallery(true);
            setUploadProgress({ current: 0, total: totalImages });

            // Upload each image
            for (let i = 0; i < formValues.image.length; i++) {
                try {
                    setUploadProgress({ current: i + 1, total: totalImages });

                    const imageresult = await generateSignature();
                    const imageFormData = new FormData();

                    imageFormData.append("file", formValues.image[i]);
                    imageFormData.append(
                        "publicKey",
                        "public_0THMWX6MF/cuVk9EPEFy+e0R0Qk="
                    );
                    imageFormData.append("signature", imageresult.data.signature);
                    imageFormData.append("expire", imageresult.data.expire);
                    imageFormData.append("token", imageresult.data.token);
                    imageFormData.append(
                        "fileName",
                        `${imageresult.data.expire}-${formValues.image[i].name}`
                    );
                    imageFormData.append("folder", galleryConfig.uploadFolder);

                    const imageUploadResult = await axios.post(
                        "https://upload.imagekit.io/api/v1/files/upload",
                        imageFormData
                    );

                    uploadedImages.push(imageUploadResult.data.url);
                } catch (err) {
                    console.error(`Failed to upload image ${i + 1}:`, err);
                }
            }

            if (uploadedImages.length === 0) {
                setIsUploadingGallery(false);
                alert("All uploads failed. Please try again.");
                return;
            }

            let updatedOrder = null;
            for (const imageUrl of uploadedImages) {
                const result = await userRequest.post(galleryConfig.addEndpoint, {
                    img: imageUrl,
                    order: modalData._id,
                });
                updatedOrder = result.data;
            }

            setIsUploadingGallery(false);
            
            // Update the orders data in the table
            if (updatedOrder && ordersData && ordersData.payload) {
                const updatedPayload = ordersData.payload.map(order => {
                    if (order._id === modalData._id) {
                        return updatedOrder;
                    }
                    return order;
                });
                setOrdersData({
                    ...ordersData,
                    payload: updatedPayload
                });
            }
            
            // Update the gallery view modal if it's open for this order
            if (updatedOrder && selectedOrderGallery && selectedOrderGallery._id === modalData._id) {
                setSelectedOrderGallery(updatedOrder);
            }
            
            // Refresh the orders list to get updated data from server
            setIsLoaded(false);
            
            resetPhotoGalleryModal();
            alert(`Successfully uploaded ${uploadedImages.length} of ${totalImages} file(s)`);
        } catch (err) {
            setIsUploadingGallery(false);
            alert("Failed to upload files");
            console.log(err);
        }
    };

    const handleWarranty = async () => {
        try {
            const formValues = getWarrantyValues();
            let newImage = undefined;

            if (formValues.image.length !== 0) {
                const imageresult = await generateSignature();
                const imageFormData = new FormData();

                imageFormData.append("file", formValues.image[0]);
                imageFormData.append(
                    "publicKey",
                    "public_0THMWX6MF/cuVk9EPEFy+e0R0Qk="
                );
                imageFormData.append("signature", imageresult.data.signature);
                imageFormData.append("expire", imageresult.data.expire);
                imageFormData.append("token", imageresult.data.token);
                imageFormData.append(
                    "fileName",
                    `${formValues.image[0].name} - ${imageresult.data.expire}`
                );
                imageFormData.append("folder", "warranty");

                const imageUploadResult = await axios.post(
                    "https://upload.imagekit.io/api/v1/files/upload",
                    imageFormData
                );

                newImage = imageUploadResult.data.url;
            }

            const result = await userRequest.post("/warrantyRequest", {
                user: currentUser._id,
                order: modalData,
                message: formValues.message,
                image: newImage,
            });

            if (result.error) {
                alert("Failed to create warranty request");
                return;
            }

            alert("Warranty request created successfully");
            setWarrantyMenu(false);
            resetWarranty();
        } catch (err) {
            console.error(err);
            alert("Failed to create warranty request");
        }
    };

    const getAdmins = useCallback(async () => {
        if (superadmin) {
            let principleParam;

            if (currentUser) {
                if (currentUser.type === "outright") {
                    principleParam = currentUser._id;
                } else if (currentUser.isSuperAdmin) {
                    principleParam = undefined;
                } else {
                    principleParam = currentUser.principle;
                }

            }
            const params = {
                isAdmin: true,
            };
            if (principleParam !== undefined) {
                params.principle = principleParam;
            }
            

            const res = await publicRequest.get("/users/allcashiers", {
                params,
            });
            setUsersData(res.data);
        }
    }, [currentUser, superadmin]);

    const getArtists = useCallback(async () => {
        let principleParam;

        if (currentUser) {
            if (currentUser.type === "outright") {
                principleParam = currentUser._id;
            } else if (currentUser.isSuperAdmin) {
                principleParam = undefined;
            } else {
                principleParam = currentUser.principle;
            }
        }

        const params = {
            type: "drafter",
            isAdmin: true,
        };
        if (principleParam !== undefined) {
            params.principle = principleParam;
        }

        const res = await publicRequest.get("/users/admin", {
            params,
        });
        setArtistsData(res.data);
    }, [currentUser]);

    const getSuppliers = async () => {
        const res = await publicRequest.get("/users/allsuppliers", {});
        setSuppliersData(res.data);
    };

    const getPurchasers = useCallback(async () => {
        let principleParam;

               if (currentUser) {
            if (currentUser.type === "outright") {
                principleParam = currentUser._id;
            } else if (currentUser.isSuperAdmin) {
                principleParam = undefined;
            } else {
                principleParam = currentUser.principle;
            }
        }

        const params = {
            type: "purchaser",
            isAdmin: true,
        };
        if (principleParam !== undefined) {
            params.principle = principleParam;
        }

        const res = await publicRequest.get("/users/admin", {
            params,
        });
        setPurchasersData(res.data);
    }, [currentUser]);

    const getProducers = useCallback(async () => {
        let principleParam;

              if (currentUser) {
            if (currentUser.type === "outright") {
                principleParam = currentUser._id;
            } else if (currentUser.isSuperAdmin) {
                principleParam = undefined;
            } else {
                principleParam = currentUser.principle;
            }
        }

        const params = {
            type: "production",
            isAdmin: true,
        };
        if (principleParam !== undefined) {
            params.principle = principleParam;
        }

        const res = await publicRequest.get("/users/admin", {
            params,
        });
        setProducersData(res.data);
    }, [currentUser]);

    const getInstallers = useCallback(async () => {
        let principleParam;

                if (currentUser) {
            if (currentUser.type === "outright") {
                principleParam = currentUser._id;
            } else if (currentUser.isSuperAdmin) {
                principleParam = undefined;
            } else {
                principleParam = currentUser.principle;
            }
        }

        const params = {
            type: "installer",
            isAdmin: true,
        };
        if (principleParam !== undefined) {
            params.principle = principleParam;
        }

        const res = await publicRequest.get("/users/admin", {
            params,
        });
        setInstallersData(res.data);
    }, [currentUser]);

    const getProductionManagers = useCallback(async () => {
        let principleParam;

        if (currentUser) {
            if (currentUser.type === "outright") {
                principleParam = currentUser._id;
            } else if (currentUser.isSuperAdmin) {
                principleParam = undefined;
            } else {
                principleParam = currentUser.principle;
            }
        }

        // Prepare params for both types
        const getUsersByType = async (type) => {
            const params = {
                type,
                isAdmin: true,
            };
            if (principleParam !== undefined) {
                params.principle = principleParam;
            }
            const res = await publicRequest.get("/users/admin", {
                params,
            });
            return res.data;
        };

        // Fetch for both types
        const [productionManagers, installationManagers] = await Promise.all([
            getUsersByType("productionManager"),
            getUsersByType("installerManager"),
        ]);

        // Merge, deduplicate by _id (optional but likely wanted)
        const mergedManagers = [
            ...productionManagers,
            ...installationManagers.filter(
                ins =>
                    !productionManagers.some(prod => prod._id === ins._id)
            ),
        ];

        setProductionManagersData(mergedManagers);
    }, [currentUser]);

    useEffect(() => {
        const timer = setTimeout(() => {
            handleSerialChange(serialNumber);
        }, 1500);

        return () => {
            clearTimeout(timer);
        };
    }, [serialNumber]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await getOrders(dispatch, inputs);
                setOrdersData(result);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setIsLoaded(true);
            }
        };

        fetchData();
        //eslint-disable-next-line
    }, [dispatch, inputs]);

    useEffect(() => {
        if (statusMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [statusMenu]);

    useEffect(() => {
        if (remarksMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [remarksMenu]);

    useEffect(() => {
        if (artistMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [artistMenu]);

    useEffect(() => {
        if (producerMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [producerMenu]);

    useEffect(() => {
        if (installerMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [installerMenu]);

    useEffect(() => {
        if (purchaserMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [purchaserMenu]);

    useEffect(() => {
        if (productionManagerMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [productionManagerMenu]);

    useEffect(() => {
        if (warrantyMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [warrantyMenu]);

    useEffect(() => {
        if (galleryModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [galleryModalState]);

    useEffect(() => {
        if (photoGalleryModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [photoGalleryModalState]);

    useEffect(() => {
        if (galleryViewModalState === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [galleryViewModalState]);

    useEffect(() => {
        if (installmentMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
            setInstallmentSubmitting(false);
        }
    }, [installmentMenu]);

    useEffect(() => {
        if (receiptMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [receiptMenu]);

    useEffect(() => {
        if (skip50Menu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [skip50Menu]);

    useEffect(() => {
        if (deliveryOrderMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [deliveryOrderMenu]);

    useEffect(() => {
        if (!galleryModalState && !photoGalleryModalState && !installmentMenu) {
            setProofPaymentType(null);
        }
    }, [galleryModalState, photoGalleryModalState, installmentMenu]);

    useEffect(() => {
        if (!installmentMenu) {
            resetInstallmentProof();
        }
    }, [installmentMenu]);

    const renderProofPaymentTypeSelect = (disabled = false) => (
        <div className="w-full mb-4 text-left">
            <label className="block text-sm font-medium text-lynch mb-2">
                Payment Type
            </label>
            <Select
                options={PAYMENT_TYPE_OPTIONS}
                value={proofPaymentType}
                onChange={setProofPaymentType}
                placeholder="Select Payment Type"
                isDisabled={disabled}
                {...commonSelectProps}
            />
        </div>
    );

    useEffect(() => {
        if (voidMenu === true) {
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
        } else {
            document.body.style.overflow = "inherit";
        }
    }, [voidMenu]);

    const handleInstallment = async (data) => {
        if (installmentSubmitting) return;

        if (installmentProofMedia.length > 0 && !proofPaymentType) {
            alert("Please select a payment type");
            return;
        }

        if (currentUser) {
            setInstallmentSubmitting(true);
            try {
                const proofOfPaymentUrls = [];

                for (const { file } of installmentProofMedia) {
                    const imageresult = await generateSignature();
                    const imageFormData = new FormData();

                    imageFormData.append("file", file);
                    imageFormData.append(
                        "publicKey",
                        "public_0THMWX6MF/cuVk9EPEFy+e0R0Qk="
                    );
                    imageFormData.append("signature", imageresult.data.signature);
                    imageFormData.append("expire", imageresult.data.expire);
                    imageFormData.append("token", imageresult.data.token);
                    imageFormData.append(
                        "fileName",
                        `${imageresult.data.expire}-${file.name}`
                    );
                    imageFormData.append("folder", "paymentproof");

                    const imageUploadResult = await axios.post(
                        "https://upload.imagekit.io/api/v1/files/upload",
                        imageFormData
                    );

                    proofOfPaymentUrls.push(imageUploadResult.data.url);
                }
                const hasProofOfPayment = proofOfPaymentUrls.length > 0;

                // Create installment request instead of directly processing installment
                const res = await userRequest.post(
                    `/installmentRequests`,
                    {
                        orderId: data._id,
                        amount: amount,
                        requestedBy: currentUser._id,
                        remarks: `Installment request for order ${data.invoiceId || data._id}`,
                        proofOfPayment: hasProofOfPayment
                            ? proofOfPaymentUrls
                            : undefined,
                        paymentType: hasProofOfPayment
                            ? proofPaymentType?.value
                            : undefined,
                        receiptNo: installmentReceiptNo.trim() || undefined,
                    }
                );

                if (res.data) {
                    alert("Installment has been added in successfully.");
                    setInstallmentMenu(false);
                    resetInstallmentProof();
                    window.location.reload();
                } else {
                    alert("Server issue, please contact support");
                    setInstallmentMenu(false);
                }
            } catch (err) {
                console.error("Error creating installment request:", err);
                const serverMessage = err.response?.data?.message;
                alert(
                    serverMessage ||
                        "Failed to create installment request. Please try again."
                );
                if (!serverMessage) {
                    setInstallmentMenu(false);
                }
            } finally {
                setInstallmentSubmitting(false);
            }
        } else {
            alert("Please login before checking out");
            setInstallmentMenu(false);
        }
    };

    const hasDeliveryOrderNo = (order) =>
        Boolean(String(order?.deliveryOrderNo || "").trim());

    const openDeliveryOrder = (order) => {
        if (hasDeliveryOrderNo(order)) {
            createDeliveryOrder(order);
            return;
        }
        setModalData(order);
        setDeliveryOrderMenu(true);
    };

    const resetDeliveryOrderModal = () => {
        if (deliveryOrderSubmitting) return;
        setDeliveryOrderMenu(false);
    };

    const handleSaveDeliveryOrderNo = async () => {
        const deliveryOrderNo = String(
            deliveryOrderNoRef.current?.value || ""
        ).trim();
        if (!deliveryOrderNo) {
            alert("Please enter a Delivery Order ID.");
            return;
        }
        if (!modalData?._id) return;

        setDeliveryOrderSubmitting(true);
        try {
            const res = await userRequest.put(`/orders/update/${modalData._id}`, {
                deliveryOrderNo,
            });
            const updatedOrder = res.data
                ? { ...res.data, deliveryOrderNo }
                : { ...modalData, deliveryOrderNo };

            if (ordersData && ordersData.payload) {
                setOrdersData({
                    ...ordersData,
                    payload: ordersData.payload.map((order) =>
                        order._id === modalData._id
                            ? { ...order, deliveryOrderNo }
                            : order
                    ),
                });
            }

            setDeliveryOrderMenu(false);
            createDeliveryOrder(updatedOrder);
        } catch (err) {
            console.error("Error saving Delivery Order ID:", err);
            alert(
                err?.response?.data?.message ||
                    "Failed to save Delivery Order ID. Please try again."
            );
        } finally {
            setDeliveryOrderSubmitting(false);
        }
    };

    const openSkip50RequestModal = (order) => {
        if (!currentUser) {
            alert("Please login first.");
            return;
        }
        if (order.skip50Percent) {
            alert("This order has already been marked to skip the 50% deposit.");
            return;
        }
        setModalData(order);
        setSkip50Remarks(
            `Skip 50% request for order ${order.invoiceId || order._id}`
        );
        setSkip50Menu(true);
    };

    const handleSkip50Request = async () => {
        try {
            const res = await userRequest.post(`/skip50Requests`, {
                order: modalData._id,
                requestedBy: currentUser._id,
                remarks:
                    skip50Remarks.trim() ||
                    `Skip 50% request for order ${modalData.invoiceId || modalData._id}`,
            });
            if (res.data) {
                setSkip50Menu(false);
                setSkip50Remarks("");
                window.dispatchEvent(new Event("skip50RequestsUpdated"));
                alert("Skip 50% request created successfully. Awaiting approval.");
            }
        } catch (err) {
            console.error("Error creating skip 50% request:", err);
            alert(
                err?.response?.data?.message ||
                    "Failed to create skip 50% request. Please try again."
            );
        }
    };

    const handlePaymentType = (e) => {
        setPayloadPaymentType(e.value);
    };

    const handleVoid = (id) => {
        voidOrder(id, dispatch);
    };

    const handleAddArtist = () => {
        const updateData = {
            artist: modalData.artist._id,
            threeDPrint: modalData.threeDPrint || false,
        };
        
        // Only include threedDrawing if 3D print is required
        if (modalData.threeDPrint && modalData.threedDrawing) {
            updateData.threedDrawing = modalData.threedDrawing;
        }
        
        updateOrder(modalData._id, updateData, dispatch);
    };

    const handleAddProducer = () => {
        updateOrder(
            modalData._id,
            { producer: modalData.producer._id },
            dispatch
        );
    };

    const handleAddInstaller = () => {
        updateOrder(
            modalData._id,
            { installer: modalData.installer._id },
            dispatch
        );
    };

    const handleAddPurchaser = () => {
        updateOrder(
            modalData._id,
            { purchaser: modalData.purchaser._id },
            dispatch
        );
    };

    const handleAddProductionManager = () => {
        updateOrder(
            modalData._id,
            { productionManager: modalData.productionManager._id },
            dispatch
        );
    };

    const handleAccept = (id) => {
        acceptOrder(id, payloadpaymentType, dispatch);
    };

    const resetAutocountDocFields = () => {
        setAutocountDocDate("");
        setAutocountDocHour12("");
        setAutocountDocMinute("");
        setAutocountDocPeriod("AM");
    };

    const handleSubmitToAutocount = async (
        orderId,
        docDate,
        hour12,
        minute,
        period
    ) => {
        if (!orderId) return;
        if (!docDate) {
            alert("Please select a document date.");
            return;
        }

        const convertedTime = to24HourTime(hour12, minute, period);
        if (!convertedTime) {
            alert("Please select a valid document time.");
            return;
        }

        setAutocountSubmitting(true);
        try {
            const res = await userRequest.post(
                `/orders/submitToAutocount/${orderId}`,
                {
                    docDate,
                    docHours: convertedTime.hours,
                    docMinutes: convertedTime.minutes,
                }
            );
            alert(
                res.data?.message ||
                    "Order submitted to Autocount successfully."
            );
            setAutocountMenu(false);
            setModalData([]);
            resetAutocountDocFields();

            // Update table immediately so the upload icon disappears
            if (ordersData && ordersData.payload) {
                const updatedPayload = ordersData.payload.map((order) => {
                    if (order._id === orderId) {
                        return {
                            ...order,
                            sentToAutocount: true,
                        };
                    }
                    return order;
                });
                setOrdersData({
                    ...ordersData,
                    payload: updatedPayload,
                });
            }

            const result = await getOrders(dispatch, inputs);
            if (result) {
                setOrdersData(result);
            }
        } catch (err) {
            console.error("Error submitting to Autocount:", err);
            const msg =
                err.response?.data?.message ||
                "Failed to submit order to Autocount.";
            alert(msg);
        } finally {
            setAutocountSubmitting(false);
        }
    };
    
    const handleInputStatus = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { 
                ...prev, 
                // Treat "All" (empty value) as no status filter
                status: e && e.value !== "" ? e.value : undefined,
            };
        });
    };

    const handleInputPaymentStatus = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, paymentStatus: e.value };
        });
    };

    const handleInputSentToAutocount = (e) => {
        setIsLoaded(false);
        setInputs((prev) => ({
            ...prev,
            sentToAutocount:
                e && e.value !== "" ? e.value : undefined,
        }));
    };

    const handleInputUser = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, cashier: e.value, principle: undefined };
        });
    };

    const handleInputPrinciple = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, principle: e.value, cashier: undefined };
        });
    };

    const handleInputArtist = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, artist: e ? e.value : undefined };
        });
    };

    const handleInputProducer = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, producer: e ? e.value : undefined };
        });
    };

    const handleInputInstaller = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, installer: e ? e.value : undefined };
        });
    };

    const handleInputPurchaser = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, purchaser: e ? e.value : undefined };
        });
    };

    const handleInputCoNumber = (value) => {
        const trimmed = value != null ? String(value).trim() : "";
        setInputs((prev) => ({
            ...prev,
            coNumber: trimmed || undefined,
            page: 1,
        }));
        setIsLoaded(false);
    };

    const handleDateFrom = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, dateFrom: e.target.value };
        });
    };

    const handleSerialChange = (e) => {
        setInputs((prev) => {
            return { ...prev, serialNumber: e };
        });
        setIsLoaded(false);
        setSerialNumber(e);
    };

    const handleDateTo = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, dateTo: e.target.value };
        });
    };

    const handleLimitChange = (e) => {
        setIsLoaded(false);
        setInputs((prev) => {
            return { ...prev, limit: e.value };
        });
    };

    const handleInvoiceChange = (e) => {
        setInputs((prev) => {
            return { ...prev, invoice: e };
        });
        setIsLoaded(false);
    };

    const resetGalleryModal = () => {
        setGalleryModalState(false);
        resetGallery();
    };

    const resetPhotoGalleryModal = () => {
        setPhotoGalleryModalState(false);
        resetPhotoGallery();
    };

    const renderImageGalleryCell = (field, original, value) => {
        const config = ORDER_IMAGE_GALLERIES[field];
        return (
            <div className="flex justify-center cursor-pointer items-center gap-2" onClick={(e) => e.stopPropagation()}>
                <div
                    className="cursor-pointer transition-transform inline-flex items-center justify-center"
                    style={{ width: '24px', height: '24px', padding: '0', boxSizing: 'border-box' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        setGalleryField(field);
                        setModalData({
                            ...original,
                        });
                        setPhotoGalleryModalState(true);
                    }}
                    title={config.addHint}
                >
                    <FiPlus className="text-green-600" style={{ width: '20px', height: '20px' }} />
                </div>
                {value && value.length > 0 ? (
                    <div
                        className="flex items-center gap-1 px-2 py-1 bg-blue-50 rounded-full hover:bg-blue-100 transition-colors cursor-pointer"
                        style={{ display: 'inline-flex', minWidth: 'fit-content' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setGalleryField(field);
                            setSelectedOrderGallery(original);
                            setGalleryViewModalState(true);
                        }}
                        title={config.viewHint}
                    >
                        <span className="text-xs font-semibold text-blue-600">
                            {value.length}
                        </span>
                        <FiFile className="text-blue-600" style={{ width: '16px', height: '16px', flexShrink: 0 }} />
                    </div>
                ) : (
                    <span className="text-xs text-gray-400"></span>
                )}
            </div>
        );
    };

    const handleDeleteGalleryImage = async (orderId, imageUrl) => {
        if (window.confirm("Are you sure you want to delete this file?")) {
            try {
                const result = await userRequest.post(galleryConfig.deleteEndpoint, {
                    img: imageUrl,
                    order: orderId,
                });

                if (result.data) {                    
                    // Update the selected order gallery state with the new data
                    setSelectedOrderGallery(result.data);
                    
                    // Update the orders data in the table
                    if (ordersData && ordersData.payload) {
                        const updatedPayload = ordersData.payload.map(order => {
                            if (order._id === orderId) {
                                return result.data;
                            }
                            return order;
                        });
                        setOrdersData({
                            ...ordersData,
                            payload: updatedPayload
                        });
                    }
                    
                    alert("Image deleted successfully");
                }
            } catch (err) {
                console.error(err);
                alert("Failed to delete image");
            }
        }
    };

    const handleDaysPendingChange = (e) => {
        setDaysPending(e.target.value);
    };

    const handleCompletionDaysChange = (e) => {
        setCompletionDays(e.target.value);
    };

    const handleSort = (columnAccessor) => {
        setIsLoaded(false);
        setInputs((prev) => {
            // If clicking the same column, toggle order
            if (prev.sortBy === columnAccessor) {
                if (prev.sortOrder === "asc") {
                    return { ...prev, sortBy: columnAccessor, sortOrder: "desc" };
                } else if (prev.sortOrder === "desc") {
                    // Clear sorting
                    return { ...prev, sortBy: columnAccessor, sortOrder: "asc" };
                }
            }
            // New column, start with ascending
            return { ...prev, sortBy: columnAccessor, sortOrder: "asc" };
        });
    };

    const handleResetFilters = () => {
        setInputs(buildDefaultFilters());
        setTextFiltersResetKey((prev) => prev + 1);
        setSerialNumber("");
        setDaysPending("");
        setCompletionDays("");
        setIsLoaded(false);
    };

    useEffect(() => {
        if (usersData[0] === undefined && process.env.REACT_APP_PROJECT !== "JINSORA") {
            getAdmins();
        }
    }, [usersData, getAdmins, dispatch]);

    useEffect(() => {
        if (regularUser) return;
        publicRequest
            .get("/users/all", { params: {} })
            .then((res) => setCustomersData(res.data || []))
            .catch((err) => console.error("Error fetching customers:", err));
    }, [regularUser]);

    const customerOptions = customersData.map((user) => ({
        label: `${user.name} - ${user.phoneNumber}`,
        value: user._id,
    }));

    const handleInputCustomer = (selected) => {
        setIsLoaded(false);
        setInputs((prev) => ({
            ...prev,
            user: selected ? selected.value : undefined,
            page: 1,
        }));
    };

    useEffect(() => {
        if (suppliersData[0] === undefined && process.env.REACT_APP_PROJECT !== "JINSORA") {
            getSuppliers();
        }
    }, [suppliersData, dispatch]);

    useEffect(() => {
        if (purchasersData[0] === undefined && process.env.REACT_APP_PROJECT !== "JINSORA") {
            getPurchasers();
        }
    }, [purchasersData, dispatch]);

    useEffect(() => {
        if (artistsData[0] === undefined && process.env.REACT_APP_PROJECT !== "JINSORA") {
            getArtists();
        }
    }, [artistsData, dispatch]);

    useEffect(() => {
        if (producersData[0] === undefined && process.env.REACT_APP_PROJECT !== "JINSORA") {
            getProducers();
        }
    }, [producersData, dispatch]);

    useEffect(() => {
        if (installersData[0] === undefined && process.env.REACT_APP_PROJECT !== "JINSORA") {
            getInstallers();
        }
    }, [installersData, dispatch]);

    useEffect(() => {
        if (purchasersData[0] === undefined) {
            getPurchasers();
        }
    }, [purchasersData, dispatch]);

    useEffect(() => {
        const fetchJournalOrderIds = async () => {
            try {
                const principleParam = superadmin
                    ? undefined
                    : principle?._id || principle;
                const filters = {
                    limit: 9999,
                    page: 1,
                    ...(principleParam && { principle: principleParam }),
                };
                const res = await publicRequest.get("/journal/history", {
                    params: { filters: JSON.stringify(filters) },
                });
                if (res.data && res.data.payload) {
                    const ids = new Set();
                    res.data.payload.forEach((journal) => {
                        if (journal.status !== "inactive") {
                            const orderId = journal.order?._id || journal.order;
                            if (orderId) ids.add(orderId.toString());
                        }
                    });
                    setOrderIdsWithJournals(ids);
                }
            } catch (error) {
                console.error("Error fetching journal data for step tracking:", error);
            }
        };
        fetchJournalOrderIds();
    }, [principle, superadmin]);

    const productColumns = [
        {
            accessor: "items",
            Header: "Item Prices (Unit)",
            sortable: false,
            Cell: ({ value }) => {
                if (!value || value.length === 0) {
                    return <div className="initialPadding">N/A</div>;
                }
                
                const priceFields = [
                    { key: 'framePrice', label: 'Frame' },
                    { key: 'steelpillarPrice', label: 'Steel Pillar' },
                    { key: 'polesupportPrice', label: 'Pole Support' },
                    { key: 'aluminiumpillarPrice', label: 'Aluminum Pillar' },
                    { key: 'stainlesssteelpillarPrice', label: 'SS Pillar' },
                    { key: 'ibeampillarPrice', label: 'I-Beam Pillar' },
                    { key: 'mainsupportPrice', label: 'Main Support' },
                    { key: 'ibeammainsupportPrice', label: 'I-Beam Main Support' },
                    { key: 'flashingcoverPrice', label: 'Flashing Cover' },
                    { key: 'aluminiumlouversPrice', label: 'Aluminium Louvers' },
                    { key: 'gutterPrice', label: 'Gutter' },
                    { key: 'gicoverPrice', label: 'G.I Cover' },
                    { key: 'uperlincoverPrice', label: 'U-Purlin Cover' },
                    { key: 'aluminiumcoverPrice', label: 'Aluminum Cover' },
                    { key: 'aluminiumSingleTlightPrice', label: 'Single T-Light' },
                    { key: 'aluminiumDoubleTlightPrice', label: 'Double T-Light' },
                    { key: 'cranePrice', label: 'Crane' },
                    { key: 'skyliftPrice', label: 'Skylift' },
                    { key: 'laminatedSafetyGlass10_38Price', label: 'Safety Glass 10.38mm' },
                    { key: 'laminatedSafetyGlass12_38Price', label: 'Safety Glass 12.38mm' },
                    { key: 'laminatedSafetyIRGlass10_76Price', label: 'IR Glass 10.76mm' },
                    { key: 'laminatedSafetyIRGlass12_76Price', label: 'IR Glass 12.76mm' },
                    { key: 'laminatedTempered11_52Price', label: 'Tempered 11.52mm' },
                    { key: 'laminatedTempered13_52Price', label: 'Tempered 13.52mm' },
                    { key: 'retractableSystemPrice', label: 'Retractable System' },
                    { key: 'ceilingPrice', label: 'Ceiling' },
                    { key: 'replacementPanelPrice', label: 'Replacement Panel' },
                    { key: 'sideHoardingPrice', label: 'Side Hoarding' },
                ];
                
                return (
                    <div className="initialPadding" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                        {value.map((item, idx) => {
                            const prices = priceFields
                                .filter(pf => item[pf.key] !== undefined && item[pf.key] !== null && item[pf.key] !== '')
                                .map(pf => ({ label: pf.label, value: item[pf.key] }));
                            
                            if (prices.length === 0) return null;
                            
                            return (
                                <div key={idx} style={{ marginBottom: '8px', padding: '8px', backgroundColor: '#f5f5f5', borderRadius: '4px', fontSize: '12px' }}>
                                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                                        Item {idx + 1} ({item.type || 'N/A'})
                                    </div>
                                    {prices.map((p, i) => (
                                        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '2px 0' }}>
                                            <span>{p.label}:</span>
                                            <span>RM {formatter.format(p.value)}</span>
                                        </div>
                                    ))}
                                </div>
                            );
                        })}
                    </div>
                );
            },
        },
        {
            accessor: "amount",
            Header: "Total Price",
            sortable: false,
            Cell: (params) => (
                <div className="initialPadding">
                    RM{" "}
                    {params.row.original.amount
                        ? formatter.format(
                              params.row.original.amount *
                                  params.row.original.price
                          )
                        : "0"}
                </div>
            ),
        },
    ];

    // 10-step process: get completed steps for an order
    const getOrderCompletedSteps = (order) => {
        const completed = [];

        const status = order.status;

        // Status-based fallback: the order status reliably indicates minimum
        // completed steps even when detailed date fields aren't populated
        // in the list API response.
        const statusImpliedSteps = {
            'purchasing':        [1, 2, 3],
            'production':        [1, 2, 3, 4],
            'productionApproved':[1, 2, 3, 4, 5, 6],
            'installing':        [1, 2, 3, 4, 5, 6, 7],
            'installApproved':   [1, 2, 3, 4, 5, 6, 7, 8],
            'completed':         [1, 2, 3, 4, 5, 6, 7, 8, 9],
        };
        const implied = statusImpliedSteps[status] || [];

        // Step 1: Open Invoice - Order created
        if (order.createdAt || implied.includes(1)) {
            completed.push(1);
        }
        // Step 2: Draft Upload - Blueprint uploaded
        if (order.uploadedDraftDate || order.blueprint?.length > 0 || implied.includes(2)) {
            completed.push(2);
        }
        // Step 3: Collect 50% - Deposit collected
        const orderTotal = order.amount || 0;
        const deposit = order.deposit || 0;
        if (
            order.depositDate ||
            order.skip50Percent === true ||
            (orderTotal > 0 && deposit >= orderTotal * 0.5) ||
            implied.includes(3)
        ) {
            completed.push(3);
        }
        // Step 4: Purchasing - Purchase order submitted or confirmed
        if (order.purchasingDate || order.purchaseOrderApprovedDate || implied.includes(4)) {
            completed.push(4);
        }
        // Step 5: Production - Production materials submitted
        if (order.productionDate || order.productionApprovalDate || implied.includes(5)) {
            completed.push(5);
        }
        // Step 6: Confirm Production - Production fully confirmed
        if (order.productionApprovalDate || implied.includes(6)) {
            completed.push(6);
        }
        // Step 7: Installer - Journal filled in by installer manager
        const journalsArray = order.journals || [];
        const activeJournals = journalsArray.filter(j => j.status !== "inactive");
        const hasJournalFromFetch = orderIdsWithJournals.has(order._id?.toString?.() || order._id);
        if (activeJournals.length > 0 || order.installingDate || implied.includes(7) || hasJournalFromFetch) {
            completed.push(7);
        }
        // Step 8: Customer Sign - Survey & sign off
        if (order.survey?.surveyDate || order.installApprovedDate || implied.includes(8)) {
            completed.push(8);
        }
        // Step 9: Complete Order - Salesman final sign off
        if (status === 'completed' || implied.includes(9)) {
            completed.push(9);
        }

        return completed;
    };

    const getOrderCurrentStep = (order) => {
        const completedSteps = getOrderCompletedSteps(order);
        const allStepIds = [1, 2, 3, 4, 5, 6, 7, 8, 9];
        return allStepIds.find(id => !completedSteps.includes(id)) || null;
    };

    /** installing status, customer survey / sign-off not yet completed */
    const isPendingCustomerSignature = (order) =>
        order.status === "installing" &&
        !order.survey?.surveyDate &&
        !order.installApprovedDate;

    /** Deposit met (deposit date or ≥50% of amount); skip50 does not count as collected. */
    const isDepositFiftyPercentCollected = (order) => {
        const orderTotal = order.amount || 0;
        const deposit = order.deposit || 0;
        return Boolean(
            order.depositDate ||
                (orderTotal > 0 && deposit >= orderTotal * 0.5)
        );
    };

    /**
     * Pending column + row highlight:
     * uploadedDraft → salesman (step 3);
     * draftApproved without deposit and without skip50 → salesman (step 3);
     * draftApproved with deposit or skip50 → purchaser (step 4);
     * productionApproved → installer (step 7), even if journal already exists.
     */
    const getEffectivePendingStep = (order) => {
        if (order.status === "uploadedDraft") return 3;
        if (order.status === "productionApproved") return 7;
        if (order.status === "draftApproved") {
            if (
                !isDepositFiftyPercentCollected(order) &&
                order.skip50Percent !== true
            ) {
                return 3;
            }
            return 4;
        }
        if (isPendingCustomerSignature(order)) {
            return 8;
        }
        return getOrderCurrentStep(order);
    };

    // Check if current user is the person responsible for the current step
    const isUserResponsibleForStep = (order, stepId) => {
        if (!currentUser) return false;
        switch (stepId) {
            case 1: // Open Invoice - Salesman
            case 3: // Collect 50% - Salesman
            case 9: // Complete Order - Salesman
                return order.cashier?._id === currentUser._id ||
                       (currentUser.type === 'staff' && !order.cashier);
            case 2: // Draft Upload - Drafter
                return order.artist?._id === currentUser._id ||
                       (currentUser.type === 'drafter' && !order.artist);
            case 4: // Purchasing - Purchaser
                return order.purchaser?._id === currentUser._id ||
                       (currentUser.type === 'purchaser' && !order.purchaser);
            case 5: // Production - Producer
            case 6: // Confirm Production - Producer
                return order.producer?._id === currentUser._id ||
                       (currentUser.type === 'production' && !order.producer);
            case 7: // Installer
                return order.installer?._id === currentUser._id ||
                       (currentUser.type === 'installerManager' && !order.installer);
            case 8: // Customer Sign — salesman follows up while installing
                if (isPendingCustomerSignature(order)) {
                    return (
                        order.cashier?._id === currentUser._id ||
                        (currentUser.type === "staff" && !order.cashier)
                    );
                }
                return order.userId?._id === currentUser._id;
            default:
                return false;
        }
    };

    // Black row: user is currently in charge of this order's active step
    const isCurrentUserInChargeOfOrder = (order) => {
        if (!currentUser) return false;
        const effectiveStep = getEffectivePendingStep(order);
        if (!effectiveStep) return false;
        return isUserResponsibleForStep(order, effectiveStep);
    };

    // Gray row: user is assigned to a future step (involved but not yet their turn)
    const isUserInvolvedInFutureStep = (order) => {
        if (!currentUser) return false;
        const effectiveStep = getEffectivePendingStep(order);
        if (!effectiveStep) return false;
        const futureSteps = [1, 2, 3, 4, 5, 6, 7, 8, 9].filter(
            (id) => id > effectiveStep
        );
        return futureSteps.some((stepId) =>
            isUserResponsibleForStep(order, stepId)
        );
    };

    const OrderActionButton = ({ codes, title, children }) => (
        <span
            className={`order-list-action-item${codes?.length ? " order-list-action-item--tagged" : ""}`}
            title={title}
        >
            {children}
            {codes?.length > 0 && (
                <span className="order-list-action-tags" aria-hidden="true">
                    {codes.map((code) => (
                        <StepCodeTag key={code} code={code} />
                    ))}
                </span>
            )}
        </span>
    );

    const columns = [
        {
            accessor: "action",
            Header: "Action",
            sortable: false,
            Cell: (params) => {
                return (
                    <div className="order-list-actions">
                        {!showSurveyBlueprintOnlyInAction && (
                            <>
                                {!accountant && (superadmin || manager || staff || outright) && (
                                    <OrderActionButton title="Void order">
                                        <Close
                                            className="pointer icon action-icon-delete"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setModalData(params.row.original._id);
                                                setVoidMenu(true);
                                            }}
                                        />
                                    </OrderActionButton>
                                )}
                            </>
                        )}
                        <OrderActionButton codes={["A3"]} title="Blueprint Link">
                            <Map
                                className="pointer icon action-icon-blueprint"
                                titleAccess="Blueprint Link"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    const blueprintUrl = `${window.location.origin}/blueprint/${params.row.original._id}`;
                                    window.open(blueprintUrl, "_blank", "noopener,noreferrer");
                                }}
                            />
                        </OrderActionButton>
                        {!showSurveyBlueprintOnlyInAction && (
                            <>
                                {(superadmin || outright || manager || staff) && params.row.original.status !== "failed" && params.row.original.paymentStatus !== "installment" && (
                                    <OrderActionButton codes={["A4/6"]} title="Installment">
                                        <VerifiedUser
                                            className="pointer icon action-icon-verify"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setModalData(params.row.original);
                                                setInstallmentMenu(true);
                                            }}
                                        />
                                    </OrderActionButton>
                                )}

                                {(params.row.original.status === "completed" ||
                                    params.row.original.status ===
                                        "installApproved") && (
                                    <OrderActionButton codes={["A7"]} title="Warranty">
                                        <AttachFile
                                            className="pointer icon action-icon-warranty"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                const original = params.row.original;
                                                setModalData(original._id);
                                                setWarrantyMenu(true);
                                            }}
                                        />
                                    </OrderActionButton>
                                )}
                            </>
                        )}
                        {!showSurveyBlueprintOnlyInAction &&
                            !installerManager &&
                            (superadmin || outright || manager || staff) &&
                            params.row.original.status !== "failed" &&
                            !params.row.original.skip50Percent && (
                                <OrderActionButton title="Request Skip 50% Deposit">
                                    <MoneyOff
                                        className="pointer icon action-icon-skip50"
                                        titleAccess="Request Skip 50% Deposit"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            openSkip50RequestModal(
                                                params.row.original
                                            );
                                        }}
                                    />
                                </OrderActionButton>
                            )}
                        {!showSurveyBlueprintOnlyInAction && !installerManager && (
                            <OrderActionButton title="Download invoice">
                                <CloudDownload
                                    className="pointer icon action-icon-download"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        createCustomerInvoice(params.row.original);
                                    }}
                                />
                            </OrderActionButton>
                        )}
                        {!showSurveyBlueprintOnlyInAction && !installerManager && canDownloadMergedInvoice && (
                            <OrderActionButton title="Download invoice (labour merged into item)">
                                <Description
                                    className="pointer icon action-icon-download-merged"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        createCustomerInvoiceMerged(
                                            params.row.original
                                        );
                                    }}
                                />
                            </OrderActionButton>
                        )}
                        {!showSurveyBlueprintOnlyInAction && !installerManager && !hideDeliveryOrder && (
                            <OrderActionButton title="Delivery Order">
                                <LocalShipping
                                    className="pointer icon action-icon-delivery-order"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        openDeliveryOrder(params.row.original);
                                    }}
                                />
                            </OrderActionButton>
                        )}
                        {!showSurveyBlueprintOnlyInAction &&
                            !installerManager &&
                            (manager || outright) &&
                            (() => {
                                const order = params.row.original;
                                const principleId =
                                    order?.principle?._id || order?.principle;
                                const isAutocountPrinciple =
                                    principleId &&
                                    String(principleId) ===
                                        "63429be7a4b0715d61b8955c";
                                if (!isAutocountPrinciple) return null;
                                if (order?.sentToAutocount) return null;
                                if (
                                    order?.status === "failed" ||
                                    order?.status === "void"
                                )
                                    return null;
                                return (
                                    <OrderActionButton title="Submit to Autocount">
                                        <FiUploadCloud
                                            className="pointer icon action-icon-autocount"
                                            title="Submit to Autocount"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setModalData(order);
                                                const defaultDocSource =
                                                    order.createdAt || new Date();
                                                const defaultDocTime =
                                                    getDefaultDocTime(new Date());
                                                setAutocountDocDate(
                                                    toDateInputValue(defaultDocSource)
                                                );
                                                setAutocountDocHour12(defaultDocTime.hour12);
                                                setAutocountDocMinute(defaultDocTime.minute);
                                                setAutocountDocPeriod(defaultDocTime.period);
                                                setAutocountMenu(true);
                                            }}
                                        />
                                    </OrderActionButton>
                                );
                            })()}
                        <OrderActionButton codes={["A5"]} title="Survey Link">
                            <FileCopy
                                className="pointer icon action-icon-copy"
                                titleAccess="Survey Link"
                                onClick={async (e) => {
                                    e.stopPropagation();
                                    const surveyUrl = `${window.location.origin}/survey/${params.row.original._id}`;
                                    window.open(surveyUrl, "_blank", "noopener,noreferrer");
                                    try {
                                        await navigator.clipboard.writeText(surveyUrl);
                                    } catch (err) {
                                        console.error("Failed to copy survey link:", err);
                                    }
                                }}
                            />
                        </OrderActionButton>
                    </div>
                );
            },
        },
        {
            Header: "Official Receipt",
            accessor: "officialReceipt",
            sortable: false,
            Cell: ({ row: { original } }) => {
                const hasAnyPayment = PAYMENT_SLOTS.some(
                    (slot) => original[paymentAmountField(slot)]
                );
                if (!hasAnyPayment) {
                    return <div className="flex justify-center"><span className="text-xs text-gray-400">-</span></div>;
                }
                return (
                    <div className="flex justify-center">
                        <span className="order-list-action-item order-list-action-item--tagged">
                            <Receipt
                                className="icon cursor-pointer"
                                style={{ color: '#4CAF50', fontSize: '20px' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setReceiptOrderData(original);
                                    setReceiptMenu(true);
                                }}
                                title="Download Official Receipt"
                            />
                            <span className="order-list-action-tags" aria-hidden="true">
                                <StepCodeTag code={OFFICIAL_RECEIPT_STEP_CODES.action} />
                            </span>
                        </span>
                    </div>
                );
            },
        },
        {
            accessor: "invoiceId",
            Header: "Invoice",
            sortable: true,
            Cell: ({ value }) => {
                return <div className="initialPadding">{value}</div>;
            },
        },
        {
            accessor: "coNumber",
            Header: "CONumber",
            sortable: false,
            Cell: ({ value }) => <div className="initialPadding">{value}</div>,
        },
        {
            accessor: "personInCharge",
            Header: "Pending",
            sortable: false,
            Cell: ({ row }) => {
                const order = row.original;
                const currentStep = getEffectivePendingStep(order);

                const formatNameWithPhone = (personObj, fallback) => {
                    if (personObj?.name && fallback !== "Customer") {
                        const phone = personObj?.phoneNumber ? ` - ( ${personObj.phoneNumber} )` : "";
                        return personObj.name + phone;
                    } else if (personObj?.name && fallback === "Customer") {
                        const phone = personObj?.phoneNumber ? ` - ( ${personObj.phoneNumber} )` : "";
                        return personObj.name + phone;
                    }
                    return fallback;
                };

                const getPersonInCharge = () => {
                    if (order.status === "completed" && order.paymentStatus === "completed") {
                        return { name: "N/A", id: null };
                    }
                    if (order.status === "void" || order.status === "failed") {
                        return { name: "N/A", id: null };
                    }

                    const stepMap = {
                        1:  { person: order.cashier,    fallback: "Salesman" },
                        2:  { person: order.artist,     fallback: "Drafter" },
                        3:  { person: order.cashier,    fallback: "Salesman" },
                        4:  { person: order.purchaser,  fallback: "Purchaser" },
                        5:  { person: order.producer,   fallback: "Producer" },
                        6:  { person: order.producer,   fallback: "Producer" },
                        7:  { person: order.installer,  fallback: "Installer" },
                        8:  { person: order.userId,     fallback: "Customer" },
                        9:  { person: order.cashier,    fallback: "Salesman" },
                    };

                    if (currentStep && stepMap[currentStep]) {
                        const info =
                            currentStep === 8 && isPendingCustomerSignature(order)
                                ? stepMap[3]
                                : stepMap[currentStep];
                        return {
                            name: formatNameWithPhone(info.person, info.fallback),
                            id: info.person?._id || null
                        };
                    }

                    return {
                        name: formatNameWithPhone(order.cashier, "Salesman"),
                        id: order.cashier?._id || null
                    };
                };

                const personInfo = getPersonInCharge();
                const youtubeLink = currentStep ? stepYouTubeLinks[currentStep] : null;
                
                return (
                    <div className="capitalize" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <span>{personInfo.name}</span>
                        {youtubeLink && (
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    window.open(youtubeLink, '_blank', 'noopener,noreferrer');
                                }}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '0.25rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#2196F3',
                                    transition: 'color 0.2s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976D2'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#2196F3'}
                                title="Watch Tutorial"
                            >
                                <FiPlay size={16} />
                            </button>
                        )}
                    </div>
                );
            },
        },
        {
            accessor: "userId",
            Header: "Customer",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding capitalize">{value ? value.name : ""}</div>
            ),
        },
        {
            accessor: "status",
            Header: "Status",
            sortable: false,
            Cell: ({ value }) => <div className="capitalize">{value}</div>,
        },
        {
            accessor: "customerApproved",
            Header: "Customer Approved",
            sortable: false,
            Cell: ({ row }) => {
                const approved = Boolean(
                    row.original.customerApprovedDate || row.original.customerApprovedBy
                );
                return (
                    <div
                        className="initialPadding"
                        style={{
                            color: approved ? "#059669" : "#dc2626",
                            fontWeight: 700,
                            fontSize: "16px",
                            textAlign: "center",
                        }}
                        title={approved ? "Customer approved" : "Not approved"}
                    >
                        {approved ? "✓" : "✗"}
                    </div>
                );
            },
        },
        {
            accessor: "paymentStatus",
            Header: "Payment Status",
            sortable: false,
            Cell: ({ value }) => <div className="capitalize">{value || 'N/A'}</div>,
        },
        {
            Header: ORDER_IMAGE_GALLERIES.paymentproof.title,
            accessor: "paymentproof",
            Cell: ({ row: { original }, value }) =>
                renderImageGalleryCell("paymentproof", original, value),
        },
        {
            Header: ORDER_IMAGE_GALLERIES.warrantyCard.title,
            accessor: "warrantyCard",
            Cell: ({ row: { original }, value }) =>
                renderImageGalleryCell("warrantyCard", original, value),
        },
        {
            accessor: "createdAt",
            Header: "Purchase Date",
            sortable: true,
            Cell: ({ value }) => (
                <div className="capitalize">
                    {" "}
                    {moment(value).format("DD/MM/YYYY")}
                </div>
            ),
        },
        {
            accessor: "commenceDate",
            Header: "Commence Date",
            sortable: true,
            Cell: ({ value }) => (
                <div className="capitalize">
                    {" "}
                    {value ? moment(value).format("DD/MM/YYYY") : ""}
                </div>
            ),
        },
        {
            accessor: "warranty",
            Header: "Warranty",
            sortable: false,
            Cell: ({ row }) => {
                const order = row.original;
                if (!order.commenceDate) {
                    return <div className="initialPadding">-</div>;
                }
                
                const googleApproved = order.survey?.googleReview?.status === "approved";
                const facebookApproved = order.survey?.facebookReview?.status === "approved";
                
                let warrantyText = "1 Year";
                if (googleApproved && facebookApproved) {
                    warrantyText = "1 Year + 12 Months";
                } else if (googleApproved) {
                    warrantyText = "1 Year + 6 Months";
                }
                
                return <div className="initialPadding">{warrantyText}</div>;
            },
        },
        {
            accessor: "completionFromApproval",
            Header: "Completion Days",
            sortable: true,
            Cell: ({ value }) => (
                <div className="initialPadding">{value ? value : "-"}</div>
            ),
        },
        {
            accessor: "completedNoPayment",
            Header: "Completed No Payment",
            sortable: true,
            Cell: ({ value }) => (
                <div className="initialPadding">{value ? value : "-"}</div>
            ),
        },
        {
            accessor: "product",
            Header: "Products",
            sortable: false,
            Cell: (params) => {
                return (
                    <div className="flex items-center justify-center">
                        {params.row.original.status === "installment" ? (
                            <div></div>
                        ) : (
                            <LocalGroceryStore
                                className="icon product-view-icon"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setModalData(params.row.original.products);
                                    setStatusMenu(true);
                                }}
                            />
                        )}
                    </div>
                );
            },
        },
        {
            accessor: "discount",
            Header: "Discount",
            sortable: true,
            Cell: ({ value }) => (
                <div className="initialPadding">
                    RM {value ? formatter.format(value) : "0"}
                </div>
            ),
        },
        {
            accessor: "deposit",
            Header: "Paid Amount",
            sortable: true,
            Cell: ({ value, row }) => {
                const total = row.original.amount - row.original.discount;
                const paidAmount = row.original.paymentStatus === "installment"
                    ? value || 0
                    : row.original.firstPayment || 0;
                const percentage = total > 0 ? (paidAmount / total * 100).toFixed(2) : 0;
                
                return (
                    <div className="initialPadding">
                        {row.original.paymentStatus === "installment"
                            ? `RM ${value ? formatter.format(value) : "0"}`
                            : `RM ${
                                  row.original.firstPayment
                                      ? formatter.format(row.original.firstPayment)
                                      : "0"
                              }`}{" "}
                        <span className="text-xs md:text-sm text-gray-700">({percentage}%)</span>
                    </div>
                );
            },
        },
        {
            accessor: "paidTotal",
            Header: "Total Paid",
            sortable: true,
            Cell: ({ value, row }) => {
                const total = row.original.amount - row.original.discount;
                const totalPaid = row.original.deposit || 0;
                const percentage = total > 0 ? (totalPaid / total * 100).toFixed(2) : 0;
                
                return (
                    <div className="initialPadding">
                        {row.original.paymentStatus === "installment"
                            ? "-"
                            : (
                                <>
                                    RM {formatter.format(row.original.deposit)}{" "}
                                    <span className="text-xs md:text-sm text-gray-700">({percentage}%)</span>
                                </>
                            )}
                    </div>
                );
            },
        },
        {
            accessor: "balance",
            Header: "Balance",
            sortable: true,
            Cell: ({ value, row }) => {
                const total = row.original.amount - row.original.discount;
                const totalPaid = row.original.deposit || 0;
                const balance = total - totalPaid;
                const percentage = total > 0 ? (balance / total * 100).toFixed(2) : 0;
                
                return (
                    <div className="initialPadding">
                        {row.original.paymentStatus === "installment"
                            ? "-"
                            : (
                                <>
                                    RM {formatter.format(balance)}{" "}
                                    <span className="text-xs md:text-sm text-gray-700">({percentage}%)</span>
                                </>
                            )}
                    </div>
                );
            },
        },
        {
            accessor: "salesNoSst",
            Header: "Sales No SST",
            sortable: false,
            Cell: ({ row }) => (
                <div className="initialPadding">
                    RM {formatter.format(getInvoiceSalesBreakdown(row.original).labourCharge || 0)}
                </div>
            ),
        },
        {
            accessor: "salesWithSst",
            Header: "Sales With SST",
            sortable: false,
            Cell: ({ row }) => (
                <div className="initialPadding">
                    RM {formatter.format(getInvoiceSalesBreakdown(row.original).productUnitPrice || 0)}
                </div>
            ),
        },
        {
            accessor: "sstAmount",
            Header: "SST",
            sortable: false,
            Cell: ({ row }) => (
                <div className="initialPadding">
                    RM {formatter.format(getInvoiceSalesBreakdown(row.original).productSst || 0)}
                </div>
            ),
        },
        {
            accessor: "products",
            Header: "Total",
            sortable: true,
            Cell: (params) => {
                const total = params.row.original.amount - params.row.original.discount;
                const percentage = total > 0 ? (100).toFixed(2) : (0).toFixed(2);
                
                return (
                    <div className="capitalize">
                        {params.row.original.paymentStatus === "installment"
                            ? "-"
                            : (
                                <>
                                    RM {formatter.format(total)}{" "}
                                    <span className="text-xs md:text-sm text-gray-700">({percentage}%)</span>
                                </>
                            )}
                    </div>
                );
            },
        },
        {
            accessor: "expenses",
            Header: "Expenses",
            sortable: true,
            Cell: (params) => {
                if (params.row.original.paymentStatus === "installment") {
                    return <div className="capitalize">-</div>;
                }

                const totalExpenses = getExpensesColumnTotal(params.row.original);

                const total = params.row.original.amount - params.row.original.discount;
                const percentage = total > 0 ? (totalExpenses / total * 100).toFixed(2) : 0;

                return (
                    <div className="capitalize">
                        {params.row.original.country === "singapore"
                            ? "$"
                            : "RM"}
                        {formatter.format(totalExpenses)}{" "}
                        <span className="text-xs md:text-sm text-gray-700">({percentage}%)</span>
                    </div>
                );
            },
        },
        {
            accessor: "profit",
            Header: "Profit",
            sortable: true,
            Cell: (params) => {
                if (params.row.original.paymentStatus === "installment") {
                    return <div className="capitalize">-</div>;
                }

                const totalExpenses = getProfitColumnExpenses(params.row.original);

                const total = params.row.original.amount - params.row.original.discount;
                const balance = total - totalExpenses;
                const percentage = total > 0 ? (balance / total * 100).toFixed(2) : 0;

                return (
                    <div className="capitalize">
                        {params.row.original.country === "singapore"
                            ? "$"
                            : "RM"}
                        {formatter.format(balance)}{" "}
                        <span className="text-xs md:text-sm text-gray-700">({percentage}%)</span>
                    </div>
                );
            },
        },
        {
            accessor: "cashier",
            Header: "Agent",
            sortable: false,
            Cell: ({ value }) => (
                <div className="initialPadding">{value ? value.name : ""}</div>
            ),
        },
        {
            accessor: "paymentType",
            Header: "Payment Type",
            sortable: false,
            Cell: ({ value }) => <div className="capitalize">{value}</div>,
        },
        {
            Header: "Drafter",
            accessor: "artist",
            Cell: ({ row: { original }, value }) => {
                const canAssign = original.status !== "completed";
                const isUserInCharge = isCurrentUserInChargeOfOrder(original);
                return (
                    <div className="flex items-center justify-center gap-2 artist-cell">
                        {original.status === "installment" ? (
                            <div></div>
                        ) : value?.name ? (
                            <>
                                <span className="artist-name" title={value.name}>
                                    {value.name}
                                </span>
                                {(superadmin || manager || staff) && canAssign && (
                                    <div
                                        className="cursor-pointer artist-edit-icon"
                                        onClick={async (e) => {
                                            e.stopPropagation();
                                            setModalData({
                                                ...original,
                                            });
                                            setArtistMenu(true);
                                        }}
                                    >
                                        <Edit />
                                    </div>
                                )}
                            </>
                        ) : (
                            (superadmin || manager || staff) && (
                                <div
                                    className="cursor-pointer artist-add-icon"
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        setModalData({
                                            ...original,
                                        });
                                        setArtistMenu(true);
                                    }}
                                    style={{ color: isUserInCharge ? '#9ca3af' : 'inherit' }}
                                >
                                    <FiPlus />
                                </div>
                            )
                        )}
                    </div>
                );
            },
        },
        {
            Header: "Producer",
            accessor: "producer",
            Cell: ({ row: { original }, value }) => {
                const canAssign = original.status !== "completed";
                return (
                    <div className="flex items-center justify-center gap-2 producer-cell">
                        {original.status === "installment" ? (
                            <div></div>
                        ) : value?.name ? (
                            <>
                                <span className="producer-name" title={value.name}>
                                    {value.name}
                                </span>
                                {(superadmin || manager) && canAssign && (
                                    <div
                                        className="cursor-pointer artist-edit-icon"
                                        onClick={async (e) => {
                                            e.stopPropagation();
                                            setModalData({
                                                ...original,
                                            });
                                            setProducerMenu(true);
                                        }}
                                    >
                                        <Edit />
                                    </div>
                                )}
                            </>
                        ) : (
                            (superadmin || manager) && canAssign && (
                                <div
                                    className="cursor-pointer producer-add-icon"
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        setModalData({
                                            ...original,
                                        });
                                        setProducerMenu(true);
                                    }}
                                >
                                    <FiPlus />
                                </div>
                            )
                        )}
                    </div>
                );
            },
        },
       
        {
            Header: "Purchaser",
            accessor: "purchaser",
            Cell: ({ row: { original }, value }) => {
                const canAssign = original.status !== "completed";
                return (
                    <div className="flex items-center justify-center gap-2 purchaser-cell">
                        {original.status === "installment" ? (
                            <div></div>
                        ) : value?.name ? (
                            <>
                                <span className="purchaser-name" title={value.name}>
                                    {value.name}
                                </span>
                                {(superadmin || manager) && canAssign && (
                                    <div
                                        className="cursor-pointer artist-edit-icon"
                                        onClick={async (e) => {
                                            e.stopPropagation();
                                            setModalData({
                                                ...original,
                                            });
                                            setPurchaserMenu(true);
                                        }}
                                    >
                                        <Edit />
                                    </div>
                                )}
                            </>
                        ) : (
                            (superadmin || manager) && canAssign && (
                                <div
                                    className="cursor-pointer purchaser-add-icon"
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        setModalData({
                                            ...original,
                                        });
                                        setPurchaserMenu(true);
                                    }}
                                >
                                    <FiPlus />
                                </div>
                            )
                        )}
                    </div>
                );
            },
        },
        {
            Header: "Production Manager",
            accessor: "productionManager",
            Cell: ({ row: { original }, value }) => {
                const canAssign = original.status !== "completed";
                const isUserInCharge = isCurrentUserInChargeOfOrder(original);
                return (
                    <div className="flex items-center justify-center gap-2 production-manager-cell">
                        {original.status === "installment" ? (
                            <div></div>
                        ) : value?.name ? (
                            <>
                                <span className="production-manager-name" title={value.name}>
                                    {value.name}
                                </span>
                                {(superadmin || manager || staff) && canAssign && (
                                    <div
                                        className="cursor-pointer artist-edit-icon"
                                        onClick={async (e) => {
                                            e.stopPropagation();
                                            setModalData({
                                                ...original,
                                            });
                                            setProductionManagerMenu(true);
                                        }}
                                    >
                                        <Edit />
                                    </div>
                                )}
                            </>
                        ) : (
                            (superadmin || manager || staff) && (
                                <div
                                    className="cursor-pointer production-manager-add-icon"
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        setModalData({
                                            ...original,
                                        });
                                        setProductionManagerMenu(true);
                                    }}
                                    style={{ color: isUserInCharge ? '#9ca3af' : 'inherit' }}
                                >
                                    <FiPlus />
                                </div>
                            )
                        )}
                    </div>
                );
            },
        },
        {
            accessor: "remark",
            Header: "Remarks",
            sortable: false,
            Cell: ({ value }) =>
                value ? (
                    <div className="flex items-center justify-center">
                        <Comment
                            className="pointer icon remarks-icon"
                            onClick={(e) => {
                                e.stopPropagation();
                                setSelectedRemarks(value);
                                setRemarksMenu(true);
                            }}
                        />
                    </div>
                ) : (
                    <div></div>
                ),
        },
    ];

    // Filter columns based on user type
    const limitedColumns = ["status", "customerApproved", "personInCharge", "paymentStatus", "createdAt", "commenceDate", "warranty", "completionFromApproval", "completedNoPayment", "product", "invoiceId", "coNumber", "userId", "remark"];
    
    let filteredColumns = showLimitedColumns
        ? columns.filter((col) => limitedColumns.includes(col.accessor) || col.accessor === "action")
        : staff
        ? columns.filter((col) => col.accessor !== "expenses" && col.accessor !== "profit")
        : (manager || outright)
        ? columns
        : columns.filter((col) => col.accessor !== "profit");
    
    // For JINSORA project, hide drafter, producer, and purchaser columns
    if (process.env.REACT_APP_PROJECT === "JINSORA") {
        filteredColumns = filteredColumns.filter((col) => 
            col.accessor !== "artist" && col.accessor !== "producer" && col.accessor !== "purchaser"
        );
    }

    // Filter orders based on days pending and completion days
    const filteredOrdersData = ordersData
        ? {
              ...ordersData,
              payload: ordersData.payload.filter((order) => {
                  // Filter by days pending
                  if (daysPending && daysPending !== "") {
                      if (!order.createdAt) return false;
                      const today = new Date();
                      const purchaseDate = new Date(order.createdAt);
                      const diffTime = today - purchaseDate;
                      const diffDays = Math.floor(
                          diffTime / (1000 * 60 * 60 * 24)
                      );
                      if (diffDays <= parseInt(daysPending)) return false;
                  }

                  // Filter by completion days
                  if (completionDays && completionDays !== "") {
                      if (!order.completionFromApproval) return false;
                      if (
                          order.completionFromApproval >
                          parseInt(completionDays)
                      )
                          return false;
                  }

                  return true;
              }),
          }
        : ordersData;

    const handleExportExcel = () => {
        const orders = filteredOrdersData?.payload || [];
        if (orders.length === 0) {
            alert("No orders to export");
            return;
        }

        const includeExpenses = filteredColumns.some((col) => col.accessor === "expenses");
        const includeProfit = filteredColumns.some((col) => col.accessor === "profit");
        const toMoney = (value) => Math.round((Number(value) || 0) * 100) / 100;

        const rows = orders.map((order, index) => {
            const isInstallment = order.paymentStatus === "installment";
            const total = (Number(order.amount) || 0) - (Number(order.discount) || 0);
            const totalPaid = Number(order.deposit) || 0;
            const salesBreakdown = getInvoiceSalesBreakdown(order);

            const row = {
                No: index + 1,
                Invoice: order.invoiceId ?? "",
                "CO Number": order.coNumber || "",
                Customer: order.userId?.name || "",
                "Phone Number": order.userId?.phoneNumber || "",
                Status: order.status || "",
                "Payment Status": order.paymentStatus || "",
                "Payment Type": getPaymentTypeLabel(order.paymentType) || order.paymentType || "",
                "Purchase Date": order.createdAt ? moment(order.createdAt).format("DD/MM/YYYY") : "",
                "Commence Date": order.commenceDate ? moment(order.commenceDate).format("DD/MM/YYYY") : "",
                Discount: toMoney(order.discount),
                "Paid Amount": toMoney(isInstallment ? order.deposit : order.firstPayment),
                "Total Paid": isInstallment ? "-" : toMoney(totalPaid),
                Balance: isInstallment ? "-" : toMoney(total - totalPaid),
                "Sales No SST": toMoney(salesBreakdown.labourCharge),
                "Sales With SST": toMoney(salesBreakdown.productUnitPrice),
                SST: toMoney(salesBreakdown.productSst),
                Total: isInstallment ? "-" : toMoney(total),
            };
            if (includeExpenses) {
                row.Expenses = isInstallment ? "-" : toMoney(getExpensesColumnTotal(order));
            }
            if (includeProfit) {
                row.Profit = isInstallment ? "-" : toMoney(total - getProfitColumnExpenses(order));
            }
            row.Agent = order.cashier?.name || "";
            row.Remarks = order.remark || "";
            return row;
        });

        excel({
            excelData: rows,
            fileName: `Orders-${moment(inputs.dateFrom).format("DD-MM-YYYY")}-to-${moment(
                inputs.dateTo
            ).format("DD-MM-YYYY")}`,
        });
    };

    return (
        <div className="order-list-page w-full max-w-full min-w-0 mx-auto px-2 sm:px-4 py-4 lg:py-8">
            {/* Filter Panel */}
            <div className="bg-white rounded-lg shadow p-2 sm:p-4 mb-6">
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3 sm:gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Date From
                        </label>
                        <input
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
                            name="dateFrom"
                            value={inputs.dateFrom}
                            type="date"
                            onChange={(e) => handleDateFrom(e)}
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Date To
                        </label>
                        <input
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
                            name="dateTo"
                            value={inputs.dateTo}
                            type="date"
                            onChange={(e) => handleDateTo(e)}
                        />
                    </div>

                    {(superadmin || manager || outright || staff || regularUser) && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Status
                            </label>
                            <Select
                                options={statusOptions.map((status, i) => {
                                    return {
                                        label: status.label,
                                        value: status.value,
                                    };
                                })}
                                value={
                                    inputs.status !== undefined
                                        ? statusOptions.find(
                                              (opt) => opt.value === inputs.status
                                          )
                                        : null
                                }
                                onChange={handleInputStatus}
                                placeholder="Select Status"
                                {...commonSelectProps}
                            />
                        </div>
                    )}

                    {(manager || outright) && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Sent to Autocount
                            </label>
                            <Select
                                options={sentToAutocountOptions}
                                value={
                                    inputs.sentToAutocount !== undefined
                                        ? sentToAutocountOptions.find(
                                              (opt) =>
                                                  opt.value ===
                                                  inputs.sentToAutocount
                                          )
                                        : null
                                }
                                onChange={handleInputSentToAutocount}
                                placeholder="All"
                                {...commonSelectProps}
                            />
                        </div>
                    )}

                    {superadmin && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Payment Status
                            </label>
                            <Select
                                options={paymentStatusOptions.map((status, i) => {
                                    return {
                                        label: status.label,
                                        value: status.value,
                                    };
                                })}
                                value={
                                    inputs.paymentStatus !== undefined
                                        ? paymentStatusOptions.find(
                                              (opt) =>
                                                  opt.value === inputs.paymentStatus
                                          )
                                        : null
                                }
                                onChange={handleInputPaymentStatus}
                                placeholder="Select Payment Status"
                                {...commonSelectProps}
                            />
                        </div>
                    )}

                    {!regularUser && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Customer
                            </label>
                            <Select
                                options={customerOptions}
                                value={
                                    inputs.user
                                        ? customerOptions.find(
                                              (opt) => opt.value === inputs.user
                                          ) || null
                                        : null
                                }
                                onChange={handleInputCustomer}
                                placeholder="Select Customer"
                                {...commonSelectProps}
                                isClearable
                            />
                        </div>
                    )}

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Invoice
                        </label>
                        <DebouncedFilterInput
                            key={`invoice-${textFiltersResetKey}`}
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
                            name="invoice"
                            type="text"
                            placeholder="Invoice Number"
                            onDebouncedChange={handleInvoiceChange}
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            CO Number
                        </label>
                        <DebouncedFilterInput
                            key={`coNumber-${textFiltersResetKey}`}
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
                            name="coNumber"
                            type="text"
                            placeholder="CO Number"
                            onDebouncedChange={handleInputCoNumber}
                        />
                    </div>

                    {superadmin && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Days Pending
                            </label>
                            <input
                                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
                                name="daysPending"
                                value={daysPending}
                                type="number"
                                min="0"
                                placeholder="Days"
                                onChange={handleDaysPendingChange}
                            />
                        </div>
                    )}

                    {superadmin && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Completion Days
                            </label>
                            <input
                                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
                                name="completionDays"
                                value={completionDays}
                                type="number"
                                min="0"
                                placeholder="Days"
                                onChange={handleCompletionDaysChange}
                            />
                        </div>
                    )}

                    {superadmin && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Cashier
                            </label>
                        <Select
                            options={usersData.map((status, i) => {
                                return {
                                    label: `${status.name}-${status.phoneNumber}-${status.username}`,
                                    value: status._id,
                                };
                            })}
                            value={
                                inputs.cashier !== undefined
                                    ? usersData.find(
                                          (user) => user._id === inputs.cashier
                                      )
                                        ? {
                                              label: `${
                                                  usersData.find(
                                                      (user) =>
                                                          user._id ===
                                                          inputs.cashier
                                                  ).name
                                              }-${
                                                  usersData.find(
                                                      (user) =>
                                                          user._id ===
                                                          inputs.cashier
                                                  ).phoneNumber
                                              }-${
                                                  usersData.find(
                                                      (user) =>
                                                          user._id ===
                                                          inputs.cashier
                                                  ).username
                                              }`,
                                              value: inputs.cashier,
                                          }
                                        : null
                                    : null
                            }
                            onChange={handleInputUser}
                            placeholder="Select Cashier"
                            onClick={() =>
                                usersData[0] === undefined ? getAdmins() : {}
                            }
                            {...commonSelectProps}
                        />
                        </div>
                    )}

                    {superadmin && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Outlet
                            </label>
                            <Select
                                options={suppliersData.map((status, i) => {
                                    return {
                                        label: `${status.name}-${status.phoneNumber}-${status.username}`,
                                        value: status._id,
                                    };
                                })}
                                value={
                                    inputs.principle !== undefined
                                        ? suppliersData.find(
                                              (supplier) =>
                                                  supplier._id ===
                                                  inputs.principle
                                          )
                                            ? {
                                                  label: `${
                                                      suppliersData.find(
                                                          (supplier) =>
                                                              supplier._id ===
                                                              inputs.principle
                                                      ).name
                                                  }-${
                                                      suppliersData.find(
                                                          (supplier) =>
                                                              supplier._id ===
                                                              inputs.principle
                                                      ).phoneNumber
                                                  }-${
                                                      suppliersData.find(
                                                          (supplier) =>
                                                              supplier._id ===
                                                              inputs.principle
                                                      ).username
                                                  }`,
                                                  value: inputs.principle,
                                              }
                                            : null
                                        : null
                                }
                                onChange={handleInputPrinciple}
                                placeholder="Select Outlet"
                                onClick={() =>
                                    suppliersData[0] === undefined
                                        ? getSuppliers()
                                        : {}
                                }
                                {...commonSelectProps}
                            />
                        </div>
                    )}

                    {superadmin && process.env.REACT_APP_PROJECT !== "JINSORA" && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Drafter
                            </label>
                            <Select
                                options={artistsData.map((artist, i) => {
                                    return {
                                        label: artist.name,
                                        value: artist._id,
                                    };
                                })}
                                value={
                                    inputs.artist !== undefined
                                        ? artistsData.find(
                                              (artist) =>
                                                  artist._id === inputs.artist
                                          )
                                            ? {
                                                  label: artistsData.find(
                                                      (artist) =>
                                                          artist._id ===
                                                          inputs.artist
                                                  ).name,
                                                  value: inputs.artist,
                                              }
                                            : null
                                        : null
                                }
                                onChange={handleInputArtist}
                                placeholder="Select Drafter"
                                onClick={() =>
                                    artistsData[0] === undefined ? getArtists() : {}
                                }
                                isClearable
                                {...commonSelectProps}
                            />
                        </div>
                    )}

                    {superadmin && process.env.REACT_APP_PROJECT !== "JINSORA" && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Producer
                            </label>
                        <Select
                            options={producersData.map((producer, i) => {
                                return {
                                    label: producer.name,
                                    value: producer._id,
                                };
                            })}
                            value={
                                inputs.producer !== undefined
                                    ? producersData.find(
                                          (producer) =>
                                              producer._id === inputs.producer
                                      )
                                        ? {
                                              label: producersData.find(
                                                  (producer) =>
                                                      producer._id ===
                                                      inputs.producer
                                              ).name,
                                              value: inputs.producer,
                                          }
                                        : null
                                    : null
                            }
                            onChange={handleInputProducer}
                            placeholder="Select Producer"
                            onClick={() =>
                                producersData[0] === undefined
                                    ? getProducers()
                                    : {}
                            }
                            isClearable
                            {...commonSelectProps}
                        />
                        </div>
                    )}


                    {superadmin && process.env.REACT_APP_PROJECT !== "JINSORA" && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Purchaser
                            </label>
                        <Select
                            options={purchasersData.map((purchaser, i) => {
                                return {
                                    label: purchaser.name,
                                    value: purchaser._id,
                                };
                            })}
                            value={
                                inputs.purchaser !== undefined
                                    ? purchasersData.find(
                                          (purchaser) =>
                                              purchaser._id === inputs.purchaser
                                      )
                                        ? {
                                              label: purchasersData.find(
                                                  (purchaser) =>
                                                      purchaser._id ===
                                                      inputs.purchaser
                                              ).name,
                                              value: inputs.purchaser,
                                          }
                                        : null
                                    : null
                            }
                            onChange={handleInputPurchaser}
                            placeholder="Select Purchaser"
                            onClick={() =>
                                purchasersData[0] === undefined
                                    ? getPurchasers()
                                    : {}
                            }
                            isClearable
                            {...commonSelectProps}
                        />
                        </div>
                    )}

                    {superadmin && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Format
                            </label>
                            <Select
                                options={limitOptions.map((status, i) => {
                                    return {
                                        label: `${status.label}`,
                                        value: status.value,
                                    };
                                })}
                                value={
                                    inputs.limit !== undefined
                                        ? limitOptions.find(
                                              (opt) =>
                                                  opt.value === inputs.limit
                                          )
                                        : null
                                }
                                onChange={handleLimitChange}
                                placeholder="Select Format"
                                {...commonSelectProps}
                            />
                        </div>
                    )}
                </div>

                <div
                    className="flex flex-wrap items-center justify-start gap-3 mt-4 w-full"
                    style={{ justifyContent: "flex-start" }}
                >
                    <button
                        type="button"
                        onClick={handleResetFilters}
                        className="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-700 shadow-sm transition-colors hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-300"
                    >
                        <FiRotateCcw className="h-4 w-4" />
                        Reset Filters
                    </button>
                    {!showLimitedColumns && (
                        <button
                            type="button"
                            onClick={handleExportExcel}
                            disabled={!filteredOrdersData?.payload?.length}
                            className="inline-flex items-center gap-2 rounded-lg bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            <FiDownload className="h-4 w-4" />
                            Export Excel
                        </button>
                    )}
                </div>
            </div>

            {/* Data Table */}
            <div className="bg-white rounded-lg shadow overflow-x-auto orders-table-wrapper max-w-full min-w-0">
                <table className={`${showLimitedColumns ? 'w-full' : 'min-w-[1200px]'} divide-y divide-gray-200 orders-table`}>
                    <thead className="bg-orange-400">
                        <tr>
                            {filteredColumns.map((column) => (
                                <th
                                    key={column.Header}
                                    className={`px-2 sm:px-6 py-2 sm:py-3 text-left text-[10px] sm:text-xs font-medium text-black uppercase tracking-wider ${
                                        column.sortable ? 'cursor-pointer hover:bg-orange-500 select-none' : ''
                                    }`}
                                    onClick={() => column.sortable && handleSort(column.accessor)}
                                >
                                    <div className="flex items-center gap-1">
                                        {column.Header}
                                        {column.sortable && (
                                            <span className="inline-flex flex-col text-[8px]">
                                                {inputs.sortBy === column.accessor && inputs.sortOrder === "asc" && (
                                                    <span>▲</span>
                                                )}
                                                {inputs.sortBy === column.accessor && inputs.sortOrder === "desc" && (
                                                    <span>▼</span>
                                                )}
                                                {inputs.sortBy !== column.accessor && (
                                                    <span className="opacity-30">⇅</span>
                                                )}
                                            </span>
                                        )}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {filteredOrdersData ? (
                            filteredOrdersData.payload.map((order) => {
                                const isUserInCharge = isCurrentUserInChargeOfOrder(order);
                                const isUserInvolved = !isUserInCharge && isUserInvolvedInFutureStep(order);
                                return (
                                <tr
                                    key={order._id}
                                    className={`${
                                        isUserInCharge
                                            ? "bg-black hover:bg-gray-800 cursor-pointer text-white"
                                            : order.status === "completed" && order.paymentStatus === "completed"
                                            ? "bg-green-200 hover:bg-green-100 cursor-pointer"
                                            : order.status === "completed" && order.paymentStatus === "pending"
                                            ? "bg-orange-200 hover:bg-orange-100 cursor-pointer"
                                            : order.status === "pending" || order.paymentStatus === "pending"
                                            ? "bg-yellow-200 hover:bg-yellow-100 cursor-pointer"
                                            : order.status === "draft"
                                            ? "bg-purple-200 hover:bg-purple-100 cursor-pointer"
                                            : order.status === "void" || order.paymentStatus === "void"
                                            ? "bg-red-200 hover:bg-red-100 cursor-pointer"
                                            : order.paymentStatus === "installment"
                                            ? "hover:bg-gray-100 cursor-not-allowed opacity-60"
                                            : "bg-yellow-200 hover:bg-yellow-100 cursor-pointer"
                                    } transition-colors duration-200`}
                                    onClick={() => {
                                        if (
                                            order.paymentStatus ===
                                            "installment"
                                        ) {
                                            return;
                                        }
                                        dispatch(clearCart());
                                        dispatch(editOrderSeedData(order));
                                        history.push(`/order/${order._id}`, {
                                            order: order,
                                        });
                                    }}
                                >
                                    {filteredColumns.map((column) => (
                                        <td
                                            key={column.accessor}
                                            className={`px-2 sm:px-6 py-2 sm:py-4 whitespace-nowrap text-[11px] sm:text-sm ${
                                                isUserInCharge ? 'text-white' : 'text-gray-900'
                                            }`}
                                        >
                                            {column.Cell
                                                ? column.Cell({
                                                      row: { original: order },
                                                      value: order[
                                                          column.accessor
                                                      ],
                                                  })
                                                : order[column.accessor]}
                                        </td>
                                    ))}
                                </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td
                                    colSpan={filteredColumns.length}
                                    className="px-2 sm:px-6 py-4 text-center text-gray-500"
                                >
                                    Loading...
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {/* Pagination */}
                {filteredOrdersData && (
                    <div className="order-list-table-footer px-4 py-3 flex items-center justify-between border-t border-gray-200">
                        <div className="order-list-table-footer-inner flex-1 flex justify-between items-center">
                            <div className="order-list-table-footer-results text-sm text-gray-700">
                                Showing{" "}
                                <span className="font-medium">
                                    {filteredOrdersData.payload.length > 0
                                        ? 1
                                        : 0}
                                </span>{" "}
                                -{" "}
                                <span className="font-medium">
                                    {filteredOrdersData.payload.length}
                                </span>{" "}
                                of{" "}
                                <span className="font-medium">
                                    {(daysPending && daysPending !== "") ||
                                    (completionDays && completionDays !== "")
                                        ? filteredOrdersData.payload.length
                                        : ordersData.totalPages}
                                </span>{" "}
                                results
                                {(daysPending && daysPending !== "") ||
                                (completionDays && completionDays !== "")
                                    ? " (filtered)"
                                    : ""}
                            </div>
                            <div className="order-list-table-footer-pagination flex space-x-2">
                                <button
                                    onClick={() =>
                                        setInputs((prev) => ({
                                            ...prev,
                                            page: 1,
                                        }))
                                    }
                                    disabled={inputs.page === 1}
                                    title="First"
                                    aria-label="First page"
                                    className={`order-list-pagination-btn px-3 py-1 rounded-md text-sm font-medium ${
                                        inputs.page === 1
                                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-orange-500"
                                    }`}
                                >
                                    <span className="order-list-pagination-icon" aria-hidden>&lt;&lt;</span>
                                    <span className="order-list-pagination-text">First</span>
                                </button>
                                <button
                                    onClick={() =>
                                        setInputs((prev) => ({
                                            ...prev,
                                            page: prev.page - 1,
                                        }))
                                    }
                                    disabled={inputs.page === 1}
                                    title="Previous"
                                    aria-label="Previous page"
                                    className={`order-list-pagination-btn px-3 py-1 rounded-md text-sm font-medium ${
                                        inputs.page === 1
                                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-orange-500"
                                    }`}
                                >
                                    <span className="order-list-pagination-icon" aria-hidden>&lt;</span>
                                    <span className="order-list-pagination-text">Previous</span>
                                </button>
                                <span className="order-list-pagination-page px-3 py-1 bg-gray-100 text-gray-900 rounded-md text-sm font-medium">
                                    Page {inputs.page} of{" "}
                                    {Math.ceil(
                                        ordersData.totalPages / inputs.limit
                                    )}
                                </span>
                                <button
                                    onClick={() =>
                                        setInputs((prev) => ({
                                            ...prev,
                                            page: prev.page + 1,
                                        }))
                                    }
                                    disabled={
                                        inputs.page >=
                                        Math.ceil(
                                            ordersData.totalPages / inputs.limit
                                        )
                                    }
                                    title="Next"
                                    aria-label="Next page"
                                    className={`order-list-pagination-btn px-3 py-1 rounded-md text-sm font-medium ${
                                        inputs.page >=
                                        Math.ceil(
                                            ordersData.totalPages / inputs.limit
                                        )
                                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-orange-500"
                                    }`}
                                >
                                    <span className="order-list-pagination-icon" aria-hidden>&gt;</span>
                                    <span className="order-list-pagination-text">Next</span>
                                </button>
                                <button
                                    onClick={() =>
                                        setInputs((prev) => ({
                                            ...prev,
                                            page: Math.ceil(
                                                ordersData.totalPages /
                                                    inputs.limit
                                            ),
                                        }))
                                    }
                                    disabled={
                                        inputs.page >=
                                        Math.ceil(
                                            ordersData.totalPages / inputs.limit
                                        )
                                    }
                                    title="Last"
                                    aria-label="Last page"
                                    className={`order-list-pagination-btn px-3 py-1 rounded-md text-sm font-medium ${
                                        inputs.page >=
                                        Math.ceil(
                                            ordersData.totalPages / inputs.limit
                                        )
                                            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                                            : "bg-orange-400 text-white hover:bg-orange-500"
                                    }`}
                                >
                                    <span className="order-list-pagination-icon" aria-hidden>&gt;&gt;</span>
                                    <span className="order-list-pagination-text">Last</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                          
            </div>

            {statusMenu && (
                <div className="overlayContainer">
                    <div className="bigcenter">
                        <div
                            className="close"
                            onClick={() => setStatusMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="updatemodalContainer">
                            <div className="updateOrder">
                                <h1 className="updateProductTitle text-xl font-semibold">
                                    Products({modalData.length})
                                </h1>
                                <Table
                                    data={modalData}
                                    columns={productColumns}
                                    hidePagination={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {voidMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setVoidMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Confirm Void Order?
                                </h3>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleVoid(modalData);
                                            setVoidMenu(false);
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setVoidMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {autocountMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => {
                                if (!autocountSubmitting) {
                                    setAutocountMenu(false);
                                    resetAutocountDocFields();
                                }
                            }}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Submit Order to Autocount?
                                </h3>
                                <p style={{ marginBottom: 12 }}>
                                    Order{" "}
                                    <strong>
                                        {modalData?.coNumber ||
                                            modalData?.invoiceId ||
                                            modalData?._id}
                                    </strong>{" "}
                                    will be pushed to Autocount as a Sales Order.
                                    This cannot be undone.
                                </p>
                                <div style={{ marginBottom: 16 }}>
                                    <label
                                        htmlFor="autocountDocDate"
                                        style={{
                                            display: "block",
                                            marginBottom: 6,
                                            fontWeight: 600,
                                        }}
                                    >
                                        Document Date
                                    </label>
                                    <input
                                        id="autocountDocDate"
                                        type="date"
                                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
                                        value={autocountDocDate}
                                        disabled={autocountSubmitting}
                                        onChange={(e) =>
                                            setAutocountDocDate(e.target.value)
                                        }
                                    />
                                </div>
                                <div style={{ marginBottom: 16 }}>
                                    <label
                                        style={{
                                            display: "block",
                                            marginBottom: 6,
                                            fontWeight: 600,
                                        }}
                                    >
                                        Document Time
                                    </label>
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "1fr auto 1fr auto",
                                            gap: 8,
                                            alignItems: "center",
                                        }}
                                    >
                                        <select
                                            id="autocountDocHour12"
                                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
                                            value={autocountDocHour12}
                                            disabled={autocountSubmitting}
                                            onChange={(e) =>
                                                setAutocountDocHour12(e.target.value)
                                            }
                                        >
                                            <option value="">Hour</option>
                                            {AUTOCOUNT_HOUR12_OPTIONS.map((hour) => (
                                                <option key={hour} value={hour}>
                                                    {hour}
                                                </option>
                                            ))}
                                        </select>
                                        <span
                                            style={{
                                                fontWeight: 700,
                                                color: "#374151",
                                            }}
                                        >
                                            :
                                        </span>
                                        <select
                                            id="autocountDocMinute"
                                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
                                            value={autocountDocMinute}
                                            disabled={autocountSubmitting}
                                            onChange={(e) =>
                                                setAutocountDocMinute(e.target.value)
                                            }
                                        >
                                            <option value="">Min</option>
                                            {AUTOCOUNT_MINUTE_OPTIONS.map((minute) => (
                                                <option key={minute} value={minute}>
                                                    {minute}
                                                </option>
                                            ))}
                                        </select>
                                        <div
                                            style={{
                                                display: "flex",
                                                border: "1px solid #d1d5db",
                                                borderRadius: 6,
                                                overflow: "hidden",
                                                minWidth: 96,
                                            }}
                                        >
                                            {["AM", "PM"].map((period) => {
                                                const isActive =
                                                    autocountDocPeriod === period;
                                                return (
                                                    <button
                                                        key={period}
                                                        type="button"
                                                        disabled={autocountSubmitting}
                                                        onClick={() =>
                                                            setAutocountDocPeriod(period)
                                                        }
                                                        style={{
                                                            flex: 1,
                                                            padding: "8px 10px",
                                                            border: "none",
                                                            cursor: autocountSubmitting
                                                                ? "not-allowed"
                                                                : "pointer",
                                                            fontWeight: 600,
                                                            fontSize: 13,
                                                            backgroundColor: isActive
                                                                ? "#f97316"
                                                                : "#ffffff",
                                                            color: isActive
                                                                ? "#ffffff"
                                                                : "#374151",
                                                            transition:
                                                                "background-color 0.15s ease",
                                                        }}
                                                    >
                                                        {period}
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        disabled={
                                            autocountSubmitting ||
                                            !autocountDocDate ||
                                            !autocountDocHour12 ||
                                            !autocountDocMinute
                                        }
                                        onClick={() => {
                                            handleSubmitToAutocount(
                                                modalData?._id,
                                                autocountDocDate,
                                                autocountDocHour12,
                                                autocountDocMinute,
                                                autocountDocPeriod
                                            );
                                        }}
                                    >
                                        {autocountSubmitting
                                            ? "Submitting..."
                                            : "Confirm"}
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        disabled={autocountSubmitting}
                                        onClick={() => {
                                            setAutocountMenu(false);
                                            resetAutocountDocFields();
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {acceptMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setAcceptMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Confirm Accept Order?
                                </h3>
                                <div className="">
                                    <label className="flex justify-start text-lynch">
                                        Payment Type
                                    </label>
                                    <Select
                                        options={paymentType.map(
                                            (paymentType, i) => {
                                                return {
                                                    label: paymentType.label,
                                                    value: paymentType.value,
                                                };
                                            }
                                        )}
                                        onChange={handlePaymentType}
                                    />
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleAccept(modalData);
                                            setAcceptMenu(false);
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setAcceptMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {artistMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setArtistMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Select Artist
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <div className="w-full mb-4">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Artist *
                                        </label>
                                        <Select
                                            className="w-full"
                                            options={artistsData.map((user) => {
                                                return {
                                                    label: user.name,
                                                    value: user._id,
                                                };
                                            })}
                                            value={
                                                modalData.artist
                                                    ? {
                                                          label: modalData
                                                              .artist.name,
                                                          value: modalData
                                                              .artist._id,
                                                      }
                                                    : null
                                            }
                                            onClick={() =>
                                                artistsData[0] === undefined
                                                    ? getArtists()
                                                    : {}
                                            }
                                            onChange={(selected) => {
                                                setModalData({
                                                    ...modalData,
                                                    artist: {
                                                        name: selected.label,
                                                        _id: selected.value,
                                                    },
                                                });
                                            }}
                                            placeholder="Choose an artist..."
                                            {...commonSelectProps}
                                        />
                                    </div>
                                    <div className="w-full mb-4">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            3D Print Required
                                        </label>
                                        <Select
                                            className="w-full"
                                            options={[
                                                { label: "False", value: false },
                                                { label: "True", value: true },
                                            ]}
                                            value={
                                                modalData.threeDPrint
                                                    ? { label: "True", value: true }
                                                    : { label: "False", value: false }
                                            }
                                            onChange={(selected) => {
                                                setModalData({
                                                    ...modalData,
                                                    threeDPrint: selected ? selected.value : false,
                                                });
                                            }}
                                            placeholder="Select 3D Print Status"
                                            {...commonSelectProps}
                                        />
                                    </div>
                                    {modalData.threeDPrint && (
                                        <div className="w-full mb-4">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                3D Expenses
                                            </label>
                                            <input
                                                type="number"
                                                step="0.01"
                                                min="0"
                                                value={modalData.threedDrawing || 0}
                                                onChange={(e) => {
                                                    setModalData({
                                                        ...modalData,
                                                        threedDrawing: parseFloat(e.target.value) || 0,
                                                    });
                                                }}
                                                className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                placeholder="0.00"
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleAddArtist();
                                            setArtistMenu(false);
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setArtistMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {producerMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setProducerMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Select Producer
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <div className="w-full mb-4">
                                        <Select
                                            className="w-full"
                                            options={producersData.map(
                                                (user) => {
                                                    return {
                                                        label: user.name,
                                                        value: user._id,
                                                    };
                                                }
                                            )}
                                            value={
                                                modalData.producer
                                                    ? {
                                                          label: modalData
                                                              .producer.name,
                                                          value: modalData
                                                              .producer._id,
                                                      }
                                                    : null
                                            }

                                            onClick={() =>
                                                producersData[0] === undefined
                                                    ? getProducers()
                                                    : {}
}
                                            onChange={(selected) => {
                                                setModalData({
                                                    ...modalData,
                                                    producer: {
                                                        name: selected.label,
                                                        _id: selected.value,
                                                    },
                                                });
                                            }}
                                            placeholder="Choose a producer..."
                                            {...commonSelectProps}
                                        />
                                    </div>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleAddProducer();
                                            setProducerMenu(false);
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setProducerMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {installerMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setInstallerMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Select Installer
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <div className="w-full mb-4">
                                        <Select
                                            className="w-full"
                                            options={installersData.map(
                                                (user) => {
                                                    return {
                                                        label: user.name,
                                                        value: user._id,
                                                    };
                                                }
                                            )}
                                            value={
                                                modalData.installer
                                                    ? {
                                                          label: modalData
                                                              .installer.name,
                                                          value: modalData
                                                              .installer._id,
                                                      }
                                                    : null
                                            }

onClick={() =>
                                                installersData[0] === undefined
                                                    ? getInstallers()
                                                    : {}
}

                                            onChange={(selected) => {
                                                setModalData({
                                                    ...modalData,
                                                    installer: {
                                                        name: selected.label,
                                                        _id: selected.value,
                                                    },
                                                });
                                            }}
                                            placeholder="Choose an installer..."
                                            {...commonSelectProps}
                                        />
                                    </div>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleAddInstaller();
                                            setInstallerMenu(false);
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setInstallerMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {purchaserMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setPurchaserMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Select Purchaser
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <div className="w-full mb-4">
                                        <Select
                                            className="w-full"
                                            options={purchasersData.map(
                                                (user) => {
                                                    return {
                                                        label: user.name,
                                                        value: user._id,
                                                    };
                                                }
                                            )}
                                            value={
                                                modalData.purchaser
                                                    ? {
                                                          label: modalData
                                                              .purchaser.name,
                                                          value: modalData
                                                              .purchaser._id,
                                                      }
                                                    : null
                                            }

                                            onClick={() =>
                                                purchasersData[0] === undefined
                                                    ? getPurchasers()
                                                    : {}
}
                                            onChange={(selected) => {
                                                setModalData({
                                                    ...modalData,
                                                    purchaser: {
                                                        name: selected.label,
                                                        _id: selected.value,
                                                    },
                                                });
                                            }}
                                            placeholder="Choose a purchaser..."
                                            {...commonSelectProps}
                                        />
                                    </div>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleAddPurchaser();
                                            setPurchaserMenu(false);
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setPurchaserMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {productionManagerMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setProductionManagerMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Select Production Manager
                                </h3>
                                <div className="flex flex-col items-center mb-4">
                                    <div className="w-full mb-4">
                                        <Select
                                            className="w-full"
                                            options={productionManagersData.map(
                                                (user) => {
                                                    return {
                                                        label: user.name,
                                                        value: user._id,
                                                    };
                                                }
                                            )}
                                            value={
                                                modalData.productionManager
                                                    ? {
                                                          label: modalData
                                                              .productionManager.name,
                                                          value: modalData
                                                              .productionManager._id,
                                                      }
                                                    : null
                                            }
                                            onClick={() =>
                                                productionManagersData[0] === undefined
                                                    ? getProductionManagers()
                                                    : {}
                                            }
                                            onChange={(selected) => {
                                                setModalData({
                                                    ...modalData,
                                                    productionManager: {
                                                        name: selected.label,
                                                        _id: selected.value,
                                                    },
                                                });
                                            }}
                                            placeholder="Choose a production manager..."
                                            {...commonSelectProps}
                                        />
                                    </div>
                                </div>
                                <div className="buttonContainer">
                                    <button
                                        className="confirm pointer green"
                                        onClick={() => {
                                            handleAddProductionManager();
                                            setProductionManagerMenu(false);
                                        }}
                                    >
                                        Confirm
                                    </button>
                                    <button
                                        className="cancel pointer red"
                                        onClick={() => {
                                            setProductionManagerMenu(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {installmentMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => {
                                if (!installmentSubmitting) {
                                    setInstallmentMenu(false);
                                }
                            }}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle mb-4">
                                    <span className="inline-flex items-center gap-2 flex-wrap justify-center">
                                        <StepCodeTag code={INSTALLMENT_STEP_CODES.modal} />
                                        Installment
                                    </span>
                                </h3>

                                <div className="flex flex-col items-stretch mb-4">
                                    <div className="w-full mb-4 text-left">
                                        <div className="flex justify-start items-center mb-2">
                                            <label className="text-sm font-medium text-lynch inline-flex items-center gap-2 flex-wrap">
                                                Receipt No (Optional)
                                            </label>
                                        </div>
                                        <input
                                            className="p-3 w-full rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                            name="receiptNo"
                                            type="text"
                                            placeholder="Receipt No (Optional)"
                                            value={installmentReceiptNo}
                                            disabled={installmentSubmitting}
                                            onChange={(e) =>
                                                setInstallmentReceiptNo(e.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="w-full mb-4">
                                        <div className="flex justify-between items-center mb-2">
                                            <label
                                                className="text-sm font-medium text-lynch inline-flex items-center gap-2 flex-wrap"
    
                                            >
                                                <StepCodeTag code={INSTALLMENT_STEP_CODES.amount} />
                                                Amount
                                            </label>
                                            <span className="text-sm font-medium text-red-600">
                                                Remaining Balance: RM{" "}
                                                {parseFloat(modalData.amount) -
                                                    parseFloat(
                                                        modalData.discount
                                                    ) -
                                                    parseFloat(
                                                        modalData.deposit || 0
                                                    )}
                                            </span>
                                        </div>
                                        <input
                                            className="p-3 w-full rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                            name="amount"
                                            type="number"
                                            placeholder="Enter payment amount"
                                            max={
                                                modalData.amount -
                                                (modalData.deposit || 0)
                                            }
                                            disabled={installmentSubmitting}
                                            onChange={(e) =>
                                                setAmount(e.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="w-full mb-4 text-left">
                                        <div className="flex justify-start items-center mb-2">
                                            <label className="text-sm font-medium text-lynch inline-flex items-center gap-2 flex-wrap">
                                                <StepCodeTag code={INSTALLMENT_STEP_CODES.proofOfPayment} />
                                                Proof of Payment
                                            </label>
                                        </div>
                                        <label
                                            className={`flex flex-col items-center justify-center gap-1 w-full p-4 rounded-lg border-2 border-dashed border-gray-300 bg-cool-gray text-center transition-colors ${installmentSubmitting ? "opacity-60 cursor-not-allowed" : "cursor-pointer hover:border-blue-400 hover:bg-blue-50"}`}
                                        >
                                            <input
                                                type="file"
                                                multiple
                                                className="hidden"
                                                disabled={installmentSubmitting}
                                                onChange={handleInstallmentProofSelect}
                                            />
                                            <FiUploadCloud className="text-blue-600" style={{ width: "28px", height: "28px" }} />
                                            <span className="text-sm font-semibold text-lynch">
                                                Click to add files
                                            </span>
                                            <span className="text-xs text-gray-500">
                                                Any file type · multiple files allowed
                                            </span>
                                            {installmentProofMedia.length > 0 && (
                                                <span className="text-xs font-semibold text-blue-600">
                                                    {installmentProofMedia.length} file{installmentProofMedia.length > 1 ? "s" : ""} selected
                                                </span>
                                            )}
                                        </label>
                                        {installmentProofMedia.length > 0 && (
                                            <div className="grid grid-cols-3 gap-3 mt-3">
                                                {installmentProofMedia.map((item) => {
                                                    const isImage = item.file.type.startsWith("image/");
                                                    const isVideo = item.file.type.startsWith("video/");
                                                    return (
                                                        <div
                                                            key={item.id}
                                                            className="relative rounded-lg border border-gray-200 bg-white overflow-hidden"
                                                        >
                                                            {isImage ? (
                                                                <img
                                                                    src={item.previewUrl}
                                                                    alt={item.file.name}
                                                                    className="w-full h-20 object-cover"
                                                                />
                                                            ) : isVideo ? (
                                                                <video
                                                                    src={item.previewUrl}
                                                                    className="w-full h-20 object-cover"
                                                                />
                                                            ) : (
                                                                <div className="w-full h-20 flex items-center justify-center bg-slate-50">
                                                                    <FiFile className="text-blue-600" style={{ width: "32px", height: "32px" }} />
                                                                </div>
                                                            )}
                                                            <button
                                                                type="button"
                                                                onClick={() => removeInstallmentProofMedia(item.id)}
                                                                disabled={installmentSubmitting}
                                                                className="absolute top-1 right-1 flex items-center justify-center w-6 h-6 rounded-full bg-black bg-opacity-60 text-white disabled:opacity-50"
                                                                aria-label="Remove file"
                                                            >
                                                                <FiX size={14} />
                                                            </button>
                                                            <div className="px-2 py-1 text-xs text-gray-600 truncate" title={item.file.name}>
                                                                {item.file.name}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                    {renderProofPaymentTypeSelect(installmentSubmitting)}
                                </div>

                                <div className="flex justify-center gap-4 mt-6">
                                    <button
                                        className="px-6 py-2 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
                                        disabled={installmentSubmitting}
                                        onClick={() => {
                                            handleInstallment(modalData);
                                        }}
                                    >
                                        {installmentSubmitting ? (
                                            "Submitting..."
                                        ) : (
                                            <span className="inline-flex items-center gap-2">
                                                <StepCodeTag code={INSTALLMENT_STEP_CODES.confirmPayment} />
                                                Confirm Payment
                                            </span>
                                        )}
                                    </button>
                                    <button
                                        className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
                                        disabled={installmentSubmitting}
                                        onClick={() => {
                                            setInstallmentMenu(false);
                                            resetInstallmentProof();
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {skip50Menu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => {
                                setSkip50Menu(false);
                                setSkip50Remarks("");
                            }}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle mb-4">
                                    Skip 50% Deposit Request
                                </h3>

                                <div className="mb-3 text-sm text-gray-700">
                                    Order:{" "}
                                    <span className="font-semibold">
                                        {modalData?.invoiceId ||
                                            modalData?.coNumber ||
                                            modalData?._id}
                                    </span>
                                </div>

                                <div className="w-full mb-4">
                                    <label className="block text-sm font-medium text-lynch mb-2">
                                        Reason / Remarks (optional)
                                    </label>
                                    <textarea
                                        className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                        rows={4}
                                        value={skip50Remarks}
                                        onChange={(e) =>
                                            setSkip50Remarks(e.target.value)
                                        }
                                        placeholder="Enter reason for skip 50% request"
                                    />
                                </div>

                                <div className="flex justify-center gap-4 mt-6">
                                    <button
                                        className="px-6 py-2 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition-colors duration-200"
                                        onClick={handleSkip50Request}
                                    >
                                        Submit Request
                                    </button>
                                    <button
                                        className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors duration-200"
                                        onClick={() => {
                                            setSkip50Menu(false);
                                            setSkip50Remarks("");
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {deliveryOrderMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={resetDeliveryOrderModal}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle mb-4">
                                    Delivery Order ID
                                </h3>

                                <div className="mb-3 text-sm text-gray-700">
                                    Order:{" "}
                                    <span className="font-semibold">
                                        {modalData?.coNumber ||
                                            modalData?.invoiceId ||
                                            modalData?._id}
                                    </span>
                                </div>

                                <div className="w-full mb-4 text-left">
                                    <label className="block text-sm font-medium text-lynch mb-2">
                                        Delivery Order ID
                                    </label>
                                    <input
                                        ref={deliveryOrderNoRef}
                                        className="p-3 w-full rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                        name="deliveryOrderNo"
                                        type="text"
                                        placeholder="Enter Delivery Order ID"
                                        defaultValue=""
                                        disabled={deliveryOrderSubmitting}
                                        autoFocus
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                handleSaveDeliveryOrderNo();
                                            }
                                        }}
                                    />
                                </div>

                                <div className="flex justify-center gap-4 mt-6">
                                    <button
                                        className="px-6 py-2 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
                                        disabled={deliveryOrderSubmitting}
                                        onClick={handleSaveDeliveryOrderNo}
                                    >
                                        {deliveryOrderSubmitting
                                            ? "Saving..."
                                            : "Confirm"}
                                    </button>
                                    <button
                                        className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
                                        disabled={deliveryOrderSubmitting}
                                        onClick={resetDeliveryOrderModal}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {warrantyMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setWarrantyMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">
                                    Warranty Request
                                </h3>
                                <form
                                    onSubmit={handleWarrantySubmit(
                                        handleWarranty
                                    )}
                                    className="w-full"
                                >
                                    <div className="flex flex-col items-stretch mb-4">
                                        <div className="w-full mb-4 text-left">
                                            <label className="flex text-sm font-medium text-lynch mb-2 items-center gap-2 flex-wrap">
                                                <StepCodeTag code={WARRANTY_REQUEST_STEP_CODES.message} />
                                                Message
                                            </label>
                                            <textarea
                                                className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                                rows="4"
                                                {...warrantyRegister("message")}
                                                placeholder="Describe the issue..."
                                            />
                                        </div>
                                        <div className="w-full text-left">
                                            <label className="flex text-sm font-medium text-lynch mb-2 items-center gap-2 flex-wrap">
                                                <StepCodeTag code={WARRANTY_REQUEST_STEP_CODES.uploadImage} />
                                                Upload Image
                                            </label>
                                            <input
                                                className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                                type="file"
                                                accept="image/*"
                                                {...warrantyRegister("image")}
                                            />
                                        </div>
                                    </div>
                                    <div className="buttonContainer">
                                        <button
                                            type="submit"
                                            className="confirm pointer green inline-flex items-center gap-2"
                                        >
                                            <StepCodeTag code={WARRANTY_REQUEST_STEP_CODES.submit} />
                                            Submit
                                        </button>
                                        <button
                                            type="button"
                                            className="cancel pointer red"
                                            onClick={() => {
                                                setWarrantyMenu(false);
                                                resetWarranty();
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {galleryModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => resetGalleryModal()}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle mb-4">
                                    Upload Payment Proof
                                </h3>
                                <form
                                    onSubmit={handleGallerySubmit(handleAddGallery)}
                                    className="w-full"
                                >
                                    <div className="flex flex-col items-center mb-4">
                                        <div className="w-full mb-4">
                                            <label className="block text-sm font-medium text-lynch mb-2">
                                                Select Image File
                                            </label>
                                            <input
                                                className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                                name="image"
                                                {...galleryRegister("image")}
                                                type="file"
                                                accept="image/*"
                                            />
                                        </div>
                                        {renderProofPaymentTypeSelect()}
                                    </div>
                                    <div className="flex justify-center gap-4 mt-6">
                                        <button
                                            type="submit"
                                            className="px-6 py-2 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition-colors duration-200"
                                        >
                                            Upload Image
                                        </button>
                                        <button
                                            type="button"
                                            className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors duration-200"
                                            onClick={() => {
                                                resetGalleryModal();
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {photoGalleryModalState && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => !isUploadingGallery && resetPhotoGalleryModal()}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle mb-4">
                                    {galleryConfig.addTitle}
                                </h3>
                                {isUploadingGallery ? (
                                    <div className="flex flex-col items-center justify-center py-12">
                                        <div className="relative">
                                            <div className="w-24 h-24 border-8 border-blue-200 rounded-full animate-pulse"></div>
                                            <div className="w-24 h-24 border-8 border-t-blue-600 border-r-transparent border-b-transparent border-l-transparent rounded-full animate-spin absolute top-0 left-0"></div>
                                        </div>
                                        <div className="mt-6 text-center">
                                            <p className="text-lg font-semibold text-gray-700 mb-2">
                                                Uploading Files...
                                            </p>
                                            <p className="text-sm text-gray-600">
                                                Processing {uploadProgress.current} of {uploadProgress.total}
                                            </p>
                                            <div className="w-64 h-2 bg-gray-200 rounded-full mt-4 overflow-hidden">
                                                <div 
                                                    className="h-full bg-blue-600 transition-all duration-300 ease-out"
                                                    style={{ width: `${(uploadProgress.current / uploadProgress.total) * 100}%` }}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <form
                                        onSubmit={handlePhotoGallerySubmit(handleAddPhotoGallery)}
                                        className="w-full"
                                    >
                                        <div className="flex flex-col items-center mb-4">
                                            <div className="w-full mb-4">
                                                <label className="block text-sm font-medium text-lynch mb-2">
                                                    Select Files (Multiple)
                                                </label>
                                                <input
                                                    className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                                    name="image"
                                                    {...photoGalleryRegister("image")}
                                                    type="file"
                                                    multiple
                                                />
                                                <p className="text-xs text-gray-500 mt-2">
                                                    💡 You can select multiple files of any type at once
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex justify-center gap-4 mt-6">
                                            <button
                                                type="submit"
                                                className="px-6 py-2 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition-colors duration-200"
                                            >
                                                Upload Files
                                            </button>
                                            <button
                                                type="button"
                                                className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors duration-200"
                                                onClick={() => {
                                                    resetPhotoGalleryModal();
                                                }}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {galleryViewModalState && selectedOrderGallery && (
                <div className="overlayContainer">
                    <div className="bigcenter">
                        <div className="updatemodalContainer" style={{ maxWidth: '1200px', width: '100%', position: 'relative' }}>
                            <div className="updateOrder">
                                <div className="flex justify-between items-center mb-6">
                                    <div className="flex-1"></div>
                                    <h3 className="updateProductTitle text-2xl font-bold text-center flex-1">
                                        {galleryConfig.title}
                                    </h3>
                                    <div className="flex-1 flex justify-end">
                                        <button
                                            onClick={() => {
                                                setGalleryViewModalState(false);
                                                setSelectedOrderGallery(null);
                                            }}
                                            className="bg-red-500 hover:bg-red-600 text-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg transition-all duration-200"
                                            title="Close"
                                        >
                                            <Close style={{ fontSize: '24px' }} />
                                        </button>
                                    </div>
                                </div>
                                <div className="flex justify-center items-center mb-6 px-4">
                                    <div className="text-sm text-gray-600">
                                        <span className="font-semibold">Total Files:</span> {selectedOrderGallery[galleryField]?.length || 0}
                                    </div>
                                </div>
                                {selectedOrderGallery[galleryField] && selectedOrderGallery[galleryField].length > 0 ? (
                                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-6 max-h-[70vh] overflow-y-auto">
                                        {selectedOrderGallery[galleryField].map((imageUrl, index) => (
                                            <div 
                                                key={index} 
                                                className="relative group rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
                                                style={{
                                                    aspectRatio: '1',
                                                    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
                                                }}
                                            >
                                                <GalleryFileTile
                                                    url={imageUrl}
                                                    alt={`${galleryConfig.imageAlt} ${index + 1}`}
                                                />
                                                {galleryField === "paymentproof" && (() => {
                                                    const proofPaymentTypeValue = selectedOrderGallery.paymentproofDetails?.find(
                                                        (detail) => detail.url === imageUrl
                                                    )?.paymentType;
                                                    return proofPaymentTypeValue ? (
                                                        <span className="absolute bottom-2 left-2 z-20 rounded-md bg-black bg-opacity-70 px-2 py-1 text-xs font-semibold text-white">
                                                            {getPaymentTypeLabel(proofPaymentTypeValue)}
                                                        </span>
                                                    ) : null;
                                                })()}
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDeleteGalleryImage(selectedOrderGallery._id, imageUrl);
                                                    }}
                                                    className="absolute z-30 bg-red-600 hover:bg-red-700 text-white rounded-full w-9 h-9 flex items-center justify-center shadow-xl transition-all duration-200 opacity-90 hover:opacity-100"
                                                    title="Delete image"
                                                    style={{
                                                        top: '1rem',
                                                        right: '0.5rem',
                                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                                        position: 'absolute',
                                                        transform: 'translateY(-50%)',
                                                    }}
                                                >
                                                    <Close style={{ fontSize: '20px', fontWeight: 'bold' }} />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="text-center py-12">
                                        <p className="text-gray-500 text-lg">{galleryConfig.emptyText}</p>
                                    </div>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            )}

            {remarksMenu && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => setRemarksMenu(false)}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer">
                            <div className="updateOrder">
                                <h3 className="updateProductTitle">Remarks</h3>
                                <div className="flex flex-col items-center mb-4">
                                    <div className="w-full mb-4">
                                        <textarea
                                            className="w-full p-3 rounded-lg bg-cool-gray border border-gray-300 font-semibold text-lynch text-sm focus:outline-none focus:ring-2 focus:ring-buttonblue"
                                            rows="6"
                                            value={selectedRemarks}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {receiptMenu && receiptOrderData && (
                <div className="overlayContainer">
                    <div className="center">
                        <div
                            className="close"
                            onClick={() => {
                                setReceiptMenu(false);
                                setReceiptOrderData(null);
                            }}
                        >
                            <Close></Close>
                        </div>
                        <div className="actionContainer" style={{ minWidth: '400px' }}>
                            <div className="updateOrder">
                                <h3 className="updateProductTitle" style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Receipt style={{ color: '#4CAF50' }} />
                                    Official Receipt
                                </h3>
                                <p style={{ marginBottom: '15px', color: '#666', fontSize: '14px' }}>
                                    CO Number: <strong>{receiptOrderData.coNumber || 'N/A'}</strong>
                                </p>
                                <p style={{ marginBottom: '20px', color: '#666', fontSize: '14px' }}>
                                    Customer: <strong>{receiptOrderData.userId?.name || 'N/A'}</strong>
                                </p>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                    {PAYMENT_SLOTS.map((slot, index) => {
                                        const amount = receiptOrderData[paymentAmountField(slot)];
                                        if (!amount) return null;
                                        return (
                                            <button
                                                key={slot.ordinal}
                                                className="confirm pointer"
                                                style={{
                                                    backgroundColor: RECEIPT_BUTTON_COLORS[index],
                                                    color: 'white',
                                                    padding: '12px 20px',
                                                    borderRadius: '8px',
                                                    border: 'none',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    fontSize: '14px',
                                                    fontWeight: '500'
                                                }}
                                                onClick={() => {
                                                    createOfficialReceipt(
                                                        receiptOrderData,
                                                        paymentReceiptType(slot),
                                                        amount,
                                                        receiptOrderData[paymentReceiptField(slot)] || ""
                                                    );
                                                }}
                                            >
                                                <span className="inline-flex items-center gap-2">
                                                    <StepCodeTag code={OFFICIAL_RECEIPT_STEP_CODES.payment} />
                                                    <span>{slot.label}</span>
                                                </span>
                                                <span>RM {formatter.format(amount)}</span>
                                            </button>
                                        );
                                    })}
                                </div>
                                <button
                                    className="cancel pointer"
                                    style={{ 
                                        marginTop: '20px',
                                        backgroundColor: '#f5f5f5', 
                                        color: '#666', 
                                        padding: '10px 20px', 
                                        borderRadius: '8px',
                                        border: '1px solid #ddd',
                                        width: '100%'
                                    }}
                                    onClick={() => {
                                        setReceiptMenu(false);
                                        setReceiptOrderData(null);
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
